import { PendoTooltip as ce, PendoIcon as ge, PendoDivider as Ai, PendoEditableContent as xs, PendoMultiselect as Ti, PendoButton as X, PendoIconButton as qi, PendoToggle as Ss, PendoLoadingIndicator as Ii, PendoAlert as ki, PendoInput as Cs, PendoFormItem as ws, PendoForm as Es, PendoModal as Kr, PendoTag as Oi, PendoPopover as Ni, PendoEmptyState as Pi, PendoTable as Di, PendoActionsCell as Mi, PendoCard as Ui } from "@pendo/components";
import { resolveComponent as x, resolveDirective as de, createElementBlock as p, openBlock as d, createElementVNode as g, createCommentVNode as O, withKeys as Br, withModifiers as Rs, createVNode as m, withDirectives as re, createTextVNode as ee, toDisplayString as U, renderSlot as te, createBlock as M, normalizeClass as $, Fragment as K, renderList as H, normalizeStyle as Hr, withCtx as I, TransitionGroup as Li, vModelText as Vi } from "vue";
import { r as _e, g as Z, i as Ae, a as le, b as zr, c as $i, d as As, e as Fi, f as Ts, h as qs, j as fe, k as Gr, l as Is, m as ji, n as Zr, o as Yr, p as ks, q as Os, s as Bi, t as Jr, u as Ie, v as be, w as ke, x as Xr, y as Wi, z as Ki, A as Ee, B as Hi } from "../get-CgQB3NDi.mjs";
const F = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, s] of t)
    r[n] = s;
  return r;
}, zi = {
  name: "CollapseDetails",
  components: {
    PendoIcon: ge
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    isExpanded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showTooltip: !1
    };
  },
  methods: {
    onExpandClick() {
      this.$emit("onExpandClick");
    },
    onNameClick() {
      this.$emit("onNameClick");
    },
    checkOverflow(e) {
      const { scrollWidth: t, clientWidth: r } = e.target;
      this.showTooltip = t > r;
    }
  }
}, Gi = { class: "collapse-details" }, Zi = { class: "collapse-details--header-left" }, Yi = { class: "collapse-details--header-right" }, Ji = {
  key: 0,
  class: "collapse-details--expand"
};
function Xi(e, t, r, n, s, a) {
  const i = x("pendo-icon"), l = de("pendo-tooltip");
  return d(), p("div", Gi, [
    g("div", {
      role: "button",
      class: "collapse-details--header",
      tabindex: "0",
      onKeydown: t[1] || (t[1] = Br(Rs((...o) => e.handleClick && e.handleClick(...o), ["stop", "prevent"]), ["space", "enter"])),
      onMouseover: t[2] || (t[2] = (o) => a.checkOverflow(o))
    }, [
      g("div", Zi, [
        m(i, {
          class: "collapse-details--header-left-icon",
          type: r.isExpanded ? "minus-square" : "plus-square",
          size: "14",
          onClick: a.onExpandClick
        }, null, 8, ["type", "onClick"]),
        re((d(), p("span", {
          class: "collapse-details--header-left-name",
          onClick: t[0] || (t[0] = (...o) => a.onNameClick && a.onNameClick(...o))
        }, [
          ee(U(r.name), 1)
        ])), [
          [l, {
            arrow: !0,
            content: s.showTooltip ? r.name : null,
            boundariesElement: "viewport",
            delay: { show: 300, hide: 0 },
            multiline: !0
          }]
        ])
      ]),
      g("div", Yi, [
        te(e.$slots, "headerRight", {}, void 0, !0)
      ])
    ], 32),
    r.isExpanded ? (d(), p("div", Ji, [
      te(e.$slots, "default", {}, void 0, !0)
    ])) : O("", !0)
  ]);
}
const Ns = /* @__PURE__ */ F(zi, [["render", Xi], ["__scopeId", "data-v-11cbd7d5"]]), Te = {
  attribute: /\[\s*(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?(?<name>[-\w\P{ASCII}]+)\s*(?:(?<operator>\W?=)\s*(?<value>.+?)\s*(\s(?<caseSensitive>[iIsS]))?\s*)?\]/gu,
  id: /#(?<name>[-\w\P{ASCII}]+)/gu,
  class: /\.(?<name>[-\w\P{ASCII}]+)/gu,
  comma: /\s*,\s*/g,
  combinator: /\s*[\s>+~]\s*/g,
  "pseudo-element": /::(?<name>[-\w\P{ASCII}]+)(?:\((?<argument>¶*)\))?/gu,
  "pseudo-class": /:(?<name>[-\w\P{ASCII}]+)(?:\((?<argument>¶*)\))?/gu,
  universal: /(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?\*/gu,
  type: /(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?(?<name>[-\w\P{ASCII}]+)/gu
  // this must be last
}, Qi = /* @__PURE__ */ new Set(["combinator", "comma"]), el = /* @__PURE__ */ new Set([
  "not",
  "is",
  "where",
  "has",
  "matches",
  "-moz-any",
  "-webkit-any",
  "nth-child",
  "nth-last-child"
]), fn = /(?<index>[\dn+-]+)\s+of\s+(?<subtree>.+)/, tl = {
  "nth-child": fn,
  "nth-last-child": fn
}, rl = (e) => {
  switch (e) {
    case "pseudo-element":
    case "pseudo-class":
      return new RegExp(Te[e].source.replace("(?<argument>¶*)", "(?<argument>.*)"), "gu");
    default:
      return Te[e];
  }
};
function nl(e, t) {
  let r = 0, n = "";
  for (; t < e.length; t++) {
    const s = e[t];
    switch (s) {
      case "(":
        ++r;
        break;
      case ")":
        --r;
        break;
    }
    if (n += s, r === 0)
      return n;
  }
  return n;
}
function al(e, t = Te) {
  if (!e)
    return [];
  const r = [e];
  for (const [s, a] of Object.entries(t))
    for (let i = 0; i < r.length; i++) {
      const l = r[i];
      if (typeof l != "string")
        continue;
      a.lastIndex = 0;
      const o = a.exec(l);
      if (!o)
        continue;
      const u = o.index - 1, c = [], f = o[0], h = l.slice(0, u + 1);
      h && c.push(h), c.push({
        ...o.groups,
        type: s,
        content: f
      });
      const b = l.slice(u + f.length + 1);
      b && c.push(b), r.splice(i, 1, ...c);
    }
  let n = 0;
  for (const s of r)
    switch (typeof s) {
      case "string":
        throw new Error(`Unexpected sequence ${s} found at index ${n}`);
      case "object":
        n += s.content.length, s.pos = [n - s.content.length, n], Qi.has(s.type) && (s.content = s.content.trim() || " ");
        break;
    }
  return r;
}
const sl = /(['"])([^\\\n]+?)\1/g, il = /\\./g;
function Ps(e, t = Te) {
  if (e = e.trim(), e === "")
    return [];
  const r = [];
  e = e.replace(il, (a, i) => (r.push({ value: a, offset: i }), "".repeat(a.length))), e = e.replace(sl, (a, i, l, o) => (r.push({ value: a, offset: o }), `${i}${"".repeat(l.length)}${i}`));
  {
    let a = 0, i;
    for (; (i = e.indexOf("(", a)) > -1; ) {
      const l = nl(e, i);
      r.push({ value: l, offset: i }), e = `${e.substring(0, i)}(${"¶".repeat(l.length - 2)})${e.substring(i + l.length)}`, a = i + l.length;
    }
  }
  const n = al(e, t), s = /* @__PURE__ */ new Set();
  for (const a of r.reverse())
    for (const i of n) {
      const { offset: l, value: o } = a;
      if (!(i.pos[0] <= l && l + o.length <= i.pos[1]))
        continue;
      const { content: u } = i, c = l - i.pos[0];
      i.content = u.slice(0, c) + o + u.slice(c + o.length), i.content !== u && s.add(i);
    }
  for (const a of s) {
    const i = rl(a.type);
    if (!i)
      throw new Error(`Unknown token type: ${a.type}`);
    i.lastIndex = 0;
    const l = i.exec(a.content);
    if (!l)
      throw new Error(`Unable to parse content for ${a.type}: ${a.content}`);
    Object.assign(a, l.groups);
  }
  return n;
}
function oe(e, { list: t = !0 } = {}) {
  if (t && e.find((r) => r.type === "comma")) {
    const r = [], n = [];
    for (let s = 0; s < e.length; s++)
      if (e[s].type === "comma") {
        if (n.length === 0)
          throw new Error("Incorrect comma at " + s);
        r.push(oe(n, { list: !1 })), n.length = 0;
      } else
        n.push(e[s]);
    if (n.length === 0)
      throw new Error("Trailing comma");
    return r.push(oe(n, { list: !1 })), { type: "list", list: r };
  }
  for (let r = e.length - 1; r >= 0; r--) {
    let n = e[r];
    if (n.type === "combinator") {
      let s = e.slice(0, r), a = e.slice(r + 1);
      return s.length === 0 ? {
        type: "relative",
        combinator: n.content,
        right: oe(a)
      } : {
        type: "complex",
        combinator: n.content,
        left: oe(s),
        right: oe(a)
      };
    }
  }
  switch (e.length) {
    case 0:
      throw new Error("Could not build AST.");
    case 1:
      return e[0];
    default:
      return {
        type: "compound",
        list: [...e]
        // clone to avoid pointers messing up the AST
      };
  }
}
function* he(e, t) {
  switch (e.type) {
    case "list":
      for (let r of e.list)
        yield* he(r, e);
      break;
    case "complex":
      yield* he(e.left, e), yield* he(e.right, e);
      break;
    case "relative":
      yield* he(e.right, e);
      break;
    case "compound":
      yield* e.list.map((r) => [r, e]);
      break;
    default:
      yield [e, t];
  }
}
function Re(e, { recursive: t = !0, list: r = !0 } = {}) {
  const n = Ps(e);
  if (!n)
    return;
  const s = oe(n, { list: r });
  if (!t)
    return s;
  for (const [a] of he(s)) {
    if (a.type !== "pseudo-class" || !a.argument || !el.has(a.name))
      continue;
    let i = a.argument;
    const l = tl[a.name];
    if (l) {
      const o = l.exec(i);
      if (!o)
        continue;
      Object.assign(a, o.groups), i = o.groups.subtree;
    }
    i && Object.assign(a, {
      subtree: Re(i, {
        recursive: !0,
        list: !0
      })
    });
  }
  return s;
}
var $e, hn;
function ll() {
  if (hn) return $e;
  hn = 1;
  var e = _e(), t = /[\\^$.*+?()[\]{}|]/g, r = RegExp(t.source);
  function n(s) {
    return s = e(s), s && r.test(s) ? s.replace(t, "\\$&") : s;
  }
  return $e = n, $e;
}
var ol = ll();
const Fe = /* @__PURE__ */ Z(ol), ul = {
  name: "SelectorEditor",
  components: {
    PendoMultiselect: Ti,
    PendoEditableContent: xs,
    PendoDivider: Ai
  },
  props: {
    category: {
      default: "",
      type: String
    },
    value: {
      default: "",
      type: String
    },
    defaultValue: {
      default: "",
      type: String
    },
    editStyle: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      textValue: "",
      dropdownSelection: ""
    };
  },
  computed: {
    dropdownOptions() {
      switch (this.category) {
        case "id":
          return ["Default", "Starts With", "Ends With", "Contains"];
        case "className":
          return ["Default", "Contains"];
        case "attrib":
          return ["Default", "Attribute Exists", "Starts With", "Ends With", "Contains"];
        default:
          return ["Default"];
      }
    },
    attributeName() {
      switch (this.category) {
        case "className":
          return "class";
        case "attrib":
          return Re(this.defaultValue).name;
        default:
          return this.category;
      }
    },
    origValue() {
      const e = Re(this.defaultValue);
      return this.category === "attrib" ? e.value.replaceAll('"', "") : e.name.replaceAll('"', "");
    },
    validationRules() {
      return [
        {
          message: "This element does not match the appropriate pattern",
          validator: (e, t) => this.validateValue(t),
          trigger: ["blur", "change"]
        }
      ];
    },
    prefix() {
      switch (this.dropdownSelection) {
        case "Starts With":
          return `[${this.attributeName}^="`;
        case "Ends With":
          return `[${this.attributeName}$="`;
        case "Contains":
          return `[${this.attributeName}*="`;
        case "Attribute Exists":
          return `[${this.attributeName}`;
        default:
          return "";
      }
    },
    preview() {
      return this.dropdownSelection === "Default" ? this.defaultValue : `${this.prefix}${this.textValue}${this.suffix}`;
    },
    suffix() {
      switch (this.dropdownSelection) {
        case "Default":
          return "";
        case "Attribute Exists":
          return "]";
        default:
          return '"]';
      }
    },
    showText() {
      return this.dropdownSelection !== "Default" && this.dropdownSelection !== "Attribute Exists";
    }
  },
  watch: {
    editStyle: {
      handler(e) {
        e !== "" && this.emitDropdown(e);
      },
      immediate: !0
    },
    value: {
      handler(e) {
        this.showText && e.includes("=") ? this.textValue = Re(e).value.replaceAll('"', "") : this.textValue = this.normalizeTextValue(e);
      },
      immediate: !0
    }
  },
  methods: {
    emitDropdown(e) {
      this.dropdownSelection = e, this.emitValue(this.textValue);
    },
    emitValue(e) {
      this.textValue = this.normalizeTextValue(e), this.$emit("update-value", {
        value: this.preview,
        editStyle: this.dropdownSelection,
        isValid: this.validateValue(e)
      });
    },
    normalizeTextValue(e) {
      return this.showText ? Ae(e) ? Ae(this.defaultValue) ? "" : this.origValue : e : "";
    },
    validateValue(e) {
      return {
        Default: new RegExp(".*"),
        "Attribute Exists": new RegExp(".*"),
        "Starts With": new RegExp(`^${Fe(e)}.*`),
        "Ends With": new RegExp(`.*${Fe(e)}$`),
        Contains: new RegExp(`.*${Fe(e)}.*`)
      }[this.dropdownSelection].test(this.origValue);
    }
  }
}, cl = { class: "selector-editor" }, dl = { class: "preview" }, fl = ["id"];
function hl(e, t, r, n, s, a) {
  const i = x("pendo-multiselect"), l = x("pendo-editable-content"), o = x("pendo-divider");
  return d(), p("div", cl, [
    t[1] || (t[1] = g("p", {
      class: "description-text",
      style: { width: "fit-content" }
    }, " Selectors are used to find features on your page. Pendo uses an exact match of the selector by default, but sometimes a more general match is useful. ", -1)),
    m(i, {
      class: "selector-editor__dropdown",
      "all-selected-text": "",
      "full-width": "",
      options: a.dropdownOptions,
      value: s.dropdownSelection,
      onSelect: a.emitDropdown
    }, null, 8, ["options", "value", "onSelect"]),
    a.showText ? (d(), M(l, {
      key: 0,
      ref: "editableContent",
      value: s.textValue,
      "validation-rules": a.validationRules,
      class: "selector-editor__input",
      style: { width: "fit-content" },
      "empty-text": s.textValue,
      "exit-event": "blur",
      onInput: a.emitValue,
      onExitEditMode: a.emitValue
    }, null, 8, ["value", "validation-rules", "empty-text", "onInput", "onExitEditMode"])) : O("", !0),
    m(o, {
      "stroke-dasharray": "2",
      stroke: "gray"
    }),
    g("div", dl, [
      t[0] || (t[0] = g("p", { class: "preview__heading" }, " Preview: ", -1)),
      g("div", {
        id: r.category,
        class: "preview__selector"
      }, U(a.preview), 9, fl)
    ])
  ]);
}
const Qr = /* @__PURE__ */ F(ul, [["render", hl], ["__scopeId", "data-v-4cac4410"]]);
class V {
  static $on(t, r) {
    const n = {
      callback: r,
      wrapper: (s) => {
        s.detail ? r(...s.detail) : r();
      }
    };
    V.callbackStore[t] === void 0 ? V.callbackStore[t] = [n] : V.callbackStore[t].push(n), V.bus.addEventListener(t, n.wrapper);
  }
  static $off(t, r) {
    if (V.callbackStore[t] === void 0)
      return;
    const n = V.callbackStore[t].findIndex((s) => s.callback === r);
    n !== -1 && (V.bus.removeEventListener(t, V.callbackStore[t][n].wrapper), V.callbackStore[t].splice(n, 1));
  }
  static $emit(t, ...r) {
    V.bus.dispatchEvent(
      new CustomEvent(t, {
        detail: r
      })
    );
  }
}
V.bus = document.createElement("div");
V.callbackStore = {};
const pl = {
  name: "ConfigureSelector",
  components: {
    SelectorEditor: Qr,
    PendoButton: X
  },
  props: {},
  data() {
    return {
      id: "",
      category: "",
      value: "",
      defaultValue: "",
      editStyle: "",
      tempValue: "",
      tempStyle: "",
      isVisible: !1,
      isValid: !0
    };
  },
  mounted() {
    V.$on("settings-click", (e) => {
      this.id = e.id, this.category = e.category, this.editStyle = e.editStyle, this.value = e.value, this.defaultValue = e.defaultValue, this.isVisible = !0;
    });
  },
  methods: {
    onCancelClick() {
      this.tempValue = "", this.value = "", this.tempStyle = "", this.editStyle = "", this.isVisible = !1;
    },
    onApplyClick() {
      V.$emit("apply-click", {
        id: this.id,
        value: this.tempValue,
        editStyle: this.tempStyle
      }), this.tempValue = "", this.value = "", this.tempStyle = "", this.editStyle = "", this.isVisible = !1;
    },
    onUpdateValue(e) {
      this.tempStyle = e.editStyle, this.tempValue = e.value, this.isValid = e.isValid;
    }
  }
}, gl = { class: "configure-selector__footer" };
function _l(e, t, r, n, s, a) {
  const i = x("selector-editor"), l = x("pendo-button");
  return d(), p("div", {
    class: $({ displayed: s.isVisible, hidden: !s.isVisible })
  }, [
    m(i, {
      category: s.category,
      value: s.value,
      "default-value": s.defaultValue,
      "edit-style": s.editStyle,
      onUpdateValue: a.onUpdateValue
    }, null, 8, ["category", "value", "default-value", "edit-style", "onUpdateValue"]),
    g("div", gl, [
      m(l, {
        class: "cancel-button",
        theme: "app",
        type: "tertiary",
        label: "Cancel",
        onClick: a.onCancelClick
      }, null, 8, ["onClick"]),
      m(l, {
        disabled: !s.isValid,
        class: "apply-button",
        theme: "app",
        type: "primary",
        label: "Apply",
        onClick: a.onApplyClick
      }, null, 8, ["disabled", "onClick"])
    ])
  ], 2);
}
const Ds = /* @__PURE__ */ F(pl, [["render", _l], ["__scopeId", "data-v-aeceb888"]]), bl = {
  name: "CountableTableExpander",
  components: {
    PendoButton: X
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    dataUnits: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      showTooltip: !1
    };
  },
  computed: {
    canExpand() {
      return this.data.length > 2;
    },
    displayData() {
      return this.canExpand && !this.isExpanded ? this.data.slice(0, 1) : this.data;
    },
    expandLabel() {
      return this.isExpanded ? `Collapse ${this.dataUnits}` : `${this.data.length - 1} more ${this.dataUnits}`;
    },
    expandIcon() {
      return this.isExpanded ? "chevron-up" : "chevron-down";
    }
  },
  methods: {
    onExpanded() {
      this.$emit("expanded", !this.isExpanded);
    },
    checkOverflow(e) {
      const { scrollWidth: t, clientWidth: r } = e.target;
      this.showTooltip = t > r;
    }
  }
};
function ml(e, t, r, n, s, a) {
  const i = x("pendo-button"), l = de("pendo-tooltip");
  return d(), p("div", {
    class: $(["countable-table-expander", { "can-expand": a.canExpand }])
  }, [
    (d(!0), p(K, null, H(a.displayData, (o, u) => re((d(), p("div", {
      key: o,
      class: $(`countable-table-expander__item-${u}`),
      onMouseover: t[0] || (t[0] = (c) => a.checkOverflow(c))
    }, [
      ee(U(o), 1)
    ], 34)), [
      [l, {
        arrow: !0,
        content: s.showTooltip ? o : null,
        boundariesElement: "viewport",
        delay: { show: 300, hide: 0 },
        multiline: !0
      }]
    ])), 128)),
    a.canExpand ? (d(), M(i, {
      key: 0,
      size: "mini",
      type: "link",
      theme: "app",
      label: a.expandLabel,
      "suffix-icon": a.expandIcon,
      "icon-size": "12",
      class: "expand",
      onClick: a.onExpanded
    }, null, 8, ["label", "suffix-icon", "onClick"])) : O("", !0)
  ], 2);
}
const en = /* @__PURE__ */ F(bl, [["render", ml], ["__scopeId", "data-v-25e4fda0"]]), vl = {
  name: "CountableTableRules",
  components: {
    PendoButton: X
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: !0
    },
    rules: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      showTooltip: !1
    };
  },
  computed: {
    canExpand() {
      return this.rules.length > 2;
    },
    displayedRules() {
      return this.canExpand && !this.isExpanded ? this.rules.slice(0, 1) : this.rules;
    },
    expandLabel() {
      return this.isExpanded ? "Collapse rules" : `${this.rules.length - 1} more rules`;
    },
    expandIcon() {
      return this.isExpanded ? "chevron-up" : "chevron-down";
    }
  },
  methods: {
    onExpanded() {
      this.$emit("expanded", !this.isExpanded);
    },
    checkOverflow(e) {
      const { scrollWidth: t, clientWidth: r } = e.target;
      this.showTooltip = t > r;
    }
  }
};
function yl(e, t, r, n, s, a) {
  const i = x("pendo-button"), l = de("pendo-tooltip");
  return d(), p("div", {
    class: $(["countable-table-rules", { "can-expand": a.canExpand }])
  }, [
    (d(!0), p(K, null, H(a.displayedRules, (o, u) => re((d(), p("div", {
      key: u,
      class: $(`countable-table-rules__rule-${u}`),
      onMouseover: t[0] || (t[0] = (c) => a.checkOverflow(c))
    }, [
      ee(U(o.rule), 1)
    ], 34)), [
      [l, {
        arrow: !0,
        content: s.showTooltip ? o.rule : null,
        boundariesElement: "viewport",
        delay: { show: 300, hide: 0 },
        multiline: !0
      }]
    ])), 128)),
    a.canExpand ? (d(), M(i, {
      key: 0,
      size: "mini",
      type: "link",
      theme: "app",
      label: a.expandLabel,
      "suffix-icon": a.expandIcon,
      "icon-size": "12",
      class: "expand",
      onClick: a.onExpanded
    }, null, 8, ["label", "suffix-icon", "onClick"])) : O("", !0)
  ], 2);
}
const Ms = /* @__PURE__ */ F(vl, [["render", yl], ["__scopeId", "data-v-09818a64"]]);
var je, pn;
function xl() {
  if (pn) return je;
  pn = 1;
  function e(t) {
    return t == null;
  }
  return je = e, je;
}
var Sl = xl();
const gn = /* @__PURE__ */ Z(Sl), Cl = {
  name: "SelectorButton",
  components: {
    PendoIcon: ge,
    PendoIconButton: qi
  },
  props: {
    id: {
      default: null,
      type: String
    },
    category: {
      default: null,
      type: String
    },
    value: {
      default: null,
      type: String
    },
    defaultValue: {
      default: null,
      type: String
    },
    color: {
      default: null,
      type: String
    },
    closable: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !0
    },
    isNodeActive: {
      type: Boolean,
      default: !1
    },
    editStyle: {
      default: null,
      type: String
    },
    configurable: {
      default: !1,
      type: Boolean
    }
  },
  computed: {
    isValidColor() {
      const e = /^#?([0-9a-f]{2}){3,4}$/i;
      return le(this.color) && e.test(this.color);
    },
    iconType() {
      return this.closable ? "x" : "plus";
    },
    isValid() {
      return !gn(this.category) && !gn(this.value);
    },
    isDisabled() {
      return !this.clickable && this.isNodeActive;
    },
    classObject() {
      const e = {
        clickable: this.clickable,
        chosen: this.closable,
        available: !this.closable
      };
      return e[`${this.category}Cat`] = !0, e;
    },
    tabIndex() {
      return this.clickable ? "0" : "-1";
    },
    styleObject() {
      const e = {};
      return this.color && (e.borderColor = this.color, e.backgroundColor = this.closable ? this.color : "#fff"), e;
    },
    editable() {
      return (this.category === "id" || this.category === "className" || this.category === "attrib") && this.closable && this.clickable && this.configurable;
    }
  },
  methods: {
    onSelectorClick(e) {
      if (this.clickable) {
        const t = {
          category: this.category,
          value: this.value,
          closable: this.closable,
          defaultValue: this.defaultValue
        };
        this.$emit("click", t);
      } else
        e.preventDefault();
    },
    onSettingsClick(e) {
      const t = {
        id: this.id,
        category: this.category,
        value: this.value,
        defaultValue: this.defaultValue,
        editStyle: this.editStyle
      };
      V.$emit("settings-click", t), e.preventDefault();
    }
  }
}, wl = ["tabindex", "disabled"], El = {
  key: 0,
  class: "crb-selector__plus"
}, Rl = { class: "crb-selector__value" }, Al = {
  key: 1,
  class: "edit-icon"
}, Tl = {
  key: 2,
  class: "crb-selector__x"
};
function ql(e, t, r, n, s, a) {
  const i = x("pendo-icon"), l = x("pendo-icon-button");
  return a.isValid ? (d(), p("button", {
    key: 0,
    class: $(["crb-selector", a.classObject]),
    style: Hr(a.styleObject),
    tabindex: a.tabIndex,
    disabled: a.isDisabled,
    onClick: t[0] || (t[0] = (...o) => a.onSelectorClick && a.onSelectorClick(...o))
  }, [
    r.closable ? O("", !0) : (d(), p("div", El, [
      m(i, {
        size: "14",
        type: "plus"
      })
    ])),
    g("span", Rl, U(r.value), 1),
    a.editable ? (d(), p("div", Al, [
      m(l, {
        "icon-size": "12",
        icon: "settings",
        onClick: Rs(a.onSettingsClick, ["stop"])
      }, null, 8, ["onClick"])
    ])) : O("", !0),
    r.closable && r.clickable ? (d(), p("div", Tl, [
      m(i, {
        size: "14",
        type: "x"
      })
    ])) : O("", !0)
  ], 14, wl)) : O("", !0);
}
const Il = /* @__PURE__ */ F(Cl, [["render", ql], ["__scopeId", "data-v-cc3f53b9"]]);
var Be, _n;
function kl() {
  if (_n) return Be;
  _n = 1;
  var e = zr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Be = t, Be;
}
var We, bn;
function Ol() {
  if (bn) return We;
  bn = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return We = e, We;
}
var Ke, mn;
function Nl() {
  if (mn) return Ke;
  mn = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Ke = e, Ke;
}
var He, vn;
function Pl() {
  if (vn) return He;
  vn = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return He = e, He;
}
var ze, yn;
function Dl() {
  if (yn) return ze;
  yn = 1;
  var e = zr(), t = $i(), r = As(), n = 200;
  function s(a, i) {
    var l = this.__data__;
    if (l instanceof e) {
      var o = l.__data__;
      if (!t || o.length < n - 1)
        return o.push([a, i]), this.size = ++l.size, this;
      l = this.__data__ = new r(o);
    }
    return l.set(a, i), this.size = l.size, this;
  }
  return ze = s, ze;
}
var Ge, xn;
function Us() {
  if (xn) return Ge;
  xn = 1;
  var e = zr(), t = kl(), r = Ol(), n = Nl(), s = Pl(), a = Dl();
  function i(l) {
    var o = this.__data__ = new e(l);
    this.size = o.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = s, i.prototype.set = a, Ge = i, Ge;
}
var Ze, Sn;
function Ml() {
  if (Sn) return Ze;
  Sn = 1;
  function e(t, r) {
    for (var n = -1, s = t == null ? 0 : t.length; ++n < s && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return Ze = e, Ze;
}
var Ye, Cn;
function Ls() {
  if (Cn) return Ye;
  Cn = 1;
  var e = Fi(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return Ye = t, Ye;
}
var Je, wn;
function Vs() {
  if (wn) return Je;
  wn = 1;
  var e = Ls();
  function t(r, n, s) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: s,
      writable: !0
    }) : r[n] = s;
  }
  return Je = t, Je;
}
var Xe, En;
function $s() {
  if (En) return Xe;
  En = 1;
  var e = Vs(), t = Ts(), r = Object.prototype, n = r.hasOwnProperty;
  function s(a, i, l) {
    var o = a[i];
    (!(n.call(a, i) && t(o, l)) || l === void 0 && !(i in a)) && e(a, i, l);
  }
  return Xe = s, Xe;
}
var Qe, Rn;
function Oe() {
  if (Rn) return Qe;
  Rn = 1;
  var e = $s(), t = Vs();
  function r(n, s, a, i) {
    var l = !a;
    a || (a = {});
    for (var o = -1, u = s.length; ++o < u; ) {
      var c = s[o], f = i ? i(a[c], n[c], c, a, n) : void 0;
      f === void 0 && (f = n[c]), l ? t(a, c, f) : e(a, c, f);
    }
    return a;
  }
  return Qe = r, Qe;
}
var et, An;
function Ul() {
  if (An) return et;
  An = 1;
  function e(t, r) {
    for (var n = -1, s = Array(t); ++n < t; )
      s[n] = r(n);
    return s;
  }
  return et = e, et;
}
var tt, Tn;
function Ll() {
  if (Tn) return tt;
  Tn = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, s) {
    var a = typeof n;
    return s = s ?? e, !!s && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < s;
  }
  return tt = r, tt;
}
var rt, qn;
function Fs() {
  if (qn) return rt;
  qn = 1;
  var e = Ul(), t = qs(), r = fe(), n = Gr(), s = Ll(), a = Is(), i = Object.prototype, l = i.hasOwnProperty;
  function o(u, c) {
    var f = r(u), h = !f && t(u), b = !f && !h && n(u), R = !f && !h && !b && a(u), _ = f || h || b || R, v = _ ? e(u.length, String) : [], C = v.length;
    for (var y in u)
      (c || l.call(u, y)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      b && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      R && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      s(y, C))) && v.push(y);
    return v;
  }
  return rt = o, rt;
}
var nt, In;
function tn() {
  if (In) return nt;
  In = 1;
  var e = Fs(), t = ji(), r = Zr();
  function n(s) {
    return r(s) ? e(s) : t(s);
  }
  return nt = n, nt;
}
var at, kn;
function Vl() {
  if (kn) return at;
  kn = 1;
  var e = Oe(), t = tn();
  function r(n, s) {
    return n && e(s, t(s), n);
  }
  return at = r, at;
}
var st, On;
function $l() {
  if (On) return st;
  On = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return st = e, st;
}
var it, Nn;
function Fl() {
  if (Nn) return it;
  Nn = 1;
  var e = Yr(), t = ks(), r = $l(), n = Object.prototype, s = n.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return r(i);
    var l = t(i), o = [];
    for (var u in i)
      u == "constructor" && (l || !s.call(i, u)) || o.push(u);
    return o;
  }
  return it = a, it;
}
var lt, Pn;
function rn() {
  if (Pn) return lt;
  Pn = 1;
  var e = Fs(), t = Fl(), r = Zr();
  function n(s) {
    return r(s) ? e(s, !0) : t(s);
  }
  return lt = n, lt;
}
var ot, Dn;
function jl() {
  if (Dn) return ot;
  Dn = 1;
  var e = Oe(), t = rn();
  function r(n, s) {
    return n && e(s, t(s), n);
  }
  return ot = r, ot;
}
var pe = { exports: {} };
pe.exports;
var Mn;
function Bl() {
  return Mn || (Mn = 1, function(e, t) {
    var r = Os(), n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, a = s && s.exports === n, i = a ? r.Buffer : void 0, l = i ? i.allocUnsafe : void 0;
    function o(u, c) {
      if (c)
        return u.slice();
      var f = u.length, h = l ? l(f) : new u.constructor(f);
      return u.copy(h), h;
    }
    e.exports = o;
  }(pe, pe.exports)), pe.exports;
}
var ut, Un;
function Wl() {
  if (Un) return ut;
  Un = 1;
  function e(t, r) {
    var n = -1, s = t.length;
    for (r || (r = Array(s)); ++n < s; )
      r[n] = t[n];
    return r;
  }
  return ut = e, ut;
}
var ct, Ln;
function Kl() {
  if (Ln) return ct;
  Ln = 1;
  function e(t, r) {
    for (var n = -1, s = t == null ? 0 : t.length, a = 0, i = []; ++n < s; ) {
      var l = t[n];
      r(l, n, t) && (i[a++] = l);
    }
    return i;
  }
  return ct = e, ct;
}
var dt, Vn;
function js() {
  if (Vn) return dt;
  Vn = 1;
  function e() {
    return [];
  }
  return dt = e, dt;
}
var ft, $n;
function nn() {
  if ($n) return ft;
  $n = 1;
  var e = Kl(), t = js(), r = Object.prototype, n = r.propertyIsEnumerable, s = Object.getOwnPropertySymbols, a = s ? function(i) {
    return i == null ? [] : (i = Object(i), e(s(i), function(l) {
      return n.call(i, l);
    }));
  } : t;
  return ft = a, ft;
}
var ht, Fn;
function Hl() {
  if (Fn) return ht;
  Fn = 1;
  var e = Oe(), t = nn();
  function r(n, s) {
    return e(n, t(n), s);
  }
  return ht = r, ht;
}
var pt, jn;
function an() {
  if (jn) return pt;
  jn = 1;
  function e(t, r) {
    for (var n = -1, s = r.length, a = t.length; ++n < s; )
      t[a + n] = r[n];
    return t;
  }
  return pt = e, pt;
}
var gt, Bn;
function Bs() {
  if (Bn) return gt;
  Bn = 1;
  var e = Bi(), t = e(Object.getPrototypeOf, Object);
  return gt = t, gt;
}
var _t, Wn;
function Ws() {
  if (Wn) return _t;
  Wn = 1;
  var e = an(), t = Bs(), r = nn(), n = js(), s = Object.getOwnPropertySymbols, a = s ? function(i) {
    for (var l = []; i; )
      e(l, r(i)), i = t(i);
    return l;
  } : n;
  return _t = a, _t;
}
var bt, Kn;
function zl() {
  if (Kn) return bt;
  Kn = 1;
  var e = Oe(), t = Ws();
  function r(n, s) {
    return e(n, t(n), s);
  }
  return bt = r, bt;
}
var mt, Hn;
function Ks() {
  if (Hn) return mt;
  Hn = 1;
  var e = an(), t = fe();
  function r(n, s, a) {
    var i = s(n);
    return t(n) ? i : e(i, a(n));
  }
  return mt = r, mt;
}
var vt, zn;
function Hs() {
  if (zn) return vt;
  zn = 1;
  var e = Ks(), t = nn(), r = tn();
  function n(s) {
    return e(s, r, t);
  }
  return vt = n, vt;
}
var yt, Gn;
function Gl() {
  if (Gn) return yt;
  Gn = 1;
  var e = Ks(), t = Ws(), r = rn();
  function n(s) {
    return e(s, r, t);
  }
  return yt = n, yt;
}
var xt, Zn;
function Zl() {
  if (Zn) return xt;
  Zn = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var s = n.length, a = new n.constructor(s);
    return s && typeof n[0] == "string" && t.call(n, "index") && (a.index = n.index, a.input = n.input), a;
  }
  return xt = r, xt;
}
var St, Yn;
function zs() {
  if (Yn) return St;
  Yn = 1;
  var e = Os(), t = e.Uint8Array;
  return St = t, St;
}
var Ct, Jn;
function sn() {
  if (Jn) return Ct;
  Jn = 1;
  var e = zs();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return Ct = t, Ct;
}
var wt, Xn;
function Yl() {
  if (Xn) return wt;
  Xn = 1;
  var e = sn();
  function t(r, n) {
    var s = n ? e(r.buffer) : r.buffer;
    return new r.constructor(s, r.byteOffset, r.byteLength);
  }
  return wt = t, wt;
}
var Et, Qn;
function Jl() {
  if (Qn) return Et;
  Qn = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return Et = t, Et;
}
var Rt, ea;
function Xl() {
  if (ea) return Rt;
  ea = 1;
  var e = Jr(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(s) {
    return r ? Object(r.call(s)) : {};
  }
  return Rt = n, Rt;
}
var At, ta;
function Ql() {
  if (ta) return At;
  ta = 1;
  var e = sn();
  function t(r, n) {
    var s = n ? e(r.buffer) : r.buffer;
    return new r.constructor(s, r.byteOffset, r.length);
  }
  return At = t, At;
}
var Tt, ra;
function eo() {
  if (ra) return Tt;
  ra = 1;
  var e = sn(), t = Yl(), r = Jl(), n = Xl(), s = Ql(), a = "[object Boolean]", i = "[object Date]", l = "[object Map]", o = "[object Number]", u = "[object RegExp]", c = "[object Set]", f = "[object String]", h = "[object Symbol]", b = "[object ArrayBuffer]", R = "[object DataView]", _ = "[object Float32Array]", v = "[object Float64Array]", C = "[object Int8Array]", y = "[object Int16Array]", T = "[object Int32Array]", S = "[object Uint8Array]", N = "[object Uint8ClampedArray]", E = "[object Uint16Array]", w = "[object Uint32Array]";
  function P(q, D, B) {
    var L = q.constructor;
    switch (D) {
      case b:
        return e(q);
      case a:
      case i:
        return new L(+q);
      case R:
        return t(q, B);
      case _:
      case v:
      case C:
      case y:
      case T:
      case S:
      case N:
      case E:
      case w:
        return s(q, B);
      case l:
        return new L();
      case o:
      case f:
        return new L(q);
      case u:
        return r(q);
      case c:
        return new L();
      case h:
        return n(q);
    }
  }
  return Tt = P, Tt;
}
var qt, na;
function to() {
  if (na) return qt;
  na = 1;
  var e = Yr(), t = Object.create, r = /* @__PURE__ */ function() {
    function n() {
    }
    return function(s) {
      if (!e(s))
        return {};
      if (t)
        return t(s);
      n.prototype = s;
      var a = new n();
      return n.prototype = void 0, a;
    };
  }();
  return qt = r, qt;
}
var It, aa;
function ro() {
  if (aa) return It;
  aa = 1;
  var e = to(), t = Bs(), r = ks();
  function n(s) {
    return typeof s.constructor == "function" && !r(s) ? e(t(s)) : {};
  }
  return It = n, It;
}
var kt, sa;
function no() {
  if (sa) return kt;
  sa = 1;
  var e = Ie(), t = be(), r = "[object Map]";
  function n(s) {
    return t(s) && e(s) == r;
  }
  return kt = n, kt;
}
var Ot, ia;
function ao() {
  if (ia) return Ot;
  ia = 1;
  var e = no(), t = ke(), r = Xr(), n = r && r.isMap, s = n ? t(n) : e;
  return Ot = s, Ot;
}
var Nt, la;
function so() {
  if (la) return Nt;
  la = 1;
  var e = Ie(), t = be(), r = "[object Set]";
  function n(s) {
    return t(s) && e(s) == r;
  }
  return Nt = n, Nt;
}
var Pt, oa;
function io() {
  if (oa) return Pt;
  oa = 1;
  var e = so(), t = ke(), r = Xr(), n = r && r.isSet, s = n ? t(n) : e;
  return Pt = s, Pt;
}
var Dt, ua;
function lo() {
  if (ua) return Dt;
  ua = 1;
  var e = Us(), t = Ml(), r = $s(), n = Vl(), s = jl(), a = Bl(), i = Wl(), l = Hl(), o = zl(), u = Hs(), c = Gl(), f = Ie(), h = Zl(), b = eo(), R = ro(), _ = fe(), v = Gr(), C = ao(), y = Yr(), T = io(), S = tn(), N = rn(), E = 1, w = 2, P = 4, q = "[object Arguments]", D = "[object Array]", B = "[object Boolean]", L = "[object Date]", W = "[object Error]", z = "[object Function]", G = "[object GeneratorFunction]", ne = "[object Map]", me = "[object Number]", ve = "[object Object]", Ne = "[object RegExp]", Pe = "[object Set]", De = "[object String]", Me = "[object Symbol]", Ue = "[object WeakMap]", Le = "[object ArrayBuffer]", Ve = "[object DataView]", gi = "[object Float32Array]", _i = "[object Float64Array]", bi = "[object Int8Array]", mi = "[object Int16Array]", vi = "[object Int32Array]", yi = "[object Uint8Array]", xi = "[object Uint8ClampedArray]", Si = "[object Uint16Array]", Ci = "[object Uint32Array]", k = {};
  k[q] = k[D] = k[Le] = k[Ve] = k[B] = k[L] = k[gi] = k[_i] = k[bi] = k[mi] = k[vi] = k[ne] = k[me] = k[ve] = k[Ne] = k[Pe] = k[De] = k[Me] = k[yi] = k[xi] = k[Si] = k[Ci] = !0, k[W] = k[z] = k[Ue] = !1;
  function ye(A, ae, se, wi, xe, Y) {
    var j, Se = ae & E, Ce = ae & w, Ei = ae & P;
    if (se && (j = xe ? se(A, wi, xe, Y) : se(A)), j !== void 0)
      return j;
    if (!y(A))
      return A;
    var on = _(A);
    if (on) {
      if (j = h(A), !Se)
        return i(A, j);
    } else {
      var ie = f(A), un = ie == z || ie == G;
      if (v(A))
        return a(A, Se);
      if (ie == ve || ie == q || un && !xe) {
        if (j = Ce || un ? {} : R(A), !Se)
          return Ce ? o(A, s(j, A)) : l(A, n(j, A));
      } else {
        if (!k[ie])
          return xe ? A : {};
        j = b(A, ie, Se);
      }
    }
    Y || (Y = new e());
    var cn = Y.get(A);
    if (cn)
      return cn;
    Y.set(A, j), T(A) ? A.forEach(function(J) {
      j.add(ye(J, ae, se, J, A, Y));
    }) : C(A) && A.forEach(function(J, Q) {
      j.set(Q, ye(J, ae, se, Q, A, Y));
    });
    var Ri = Ei ? Ce ? c : u : Ce ? N : S, dn = on ? void 0 : Ri(A);
    return t(dn || A, function(J, Q) {
      dn && (Q = J, J = A[Q]), r(j, Q, ye(J, ae, se, Q, A, Y));
    }), j;
  }
  return Dt = ye, Dt;
}
var Mt, ca;
function oo() {
  if (ca) return Mt;
  ca = 1;
  var e = lo(), t = 1, r = 4;
  function n(s) {
    return e(s, t | r);
  }
  return Mt = n, Mt;
}
var uo = oo();
const da = /* @__PURE__ */ Z(uo), co = {
  compatConfig: {
    INSTANCE_LISTENERS: !1
  },
  name: "SelectorNode",
  components: {
    SelectorButton: Il
  },
  props: {
    id: {
      default: "",
      type: String
    },
    selectors: {
      default: () => [],
      type: Array
    },
    active: {
      default: !1,
      type: Boolean
    },
    showUnusedNodes: {
      default: !1,
      type: Boolean
    },
    siblings: {
      default: () => [],
      type: Array
    },
    shadowNode: {
      default: !1,
      type: Boolean
    },
    configurable: {
      default: !1,
      type: Boolean
    }
  },
  emits: ["update-selector-node"],
  data() {
    return {
      allSelectors: [],
      siblingSelectors: [],
      unusedSelectors: [],
      chosenSelectorMap: {},
      chosenSiblingMap: {}
    };
  },
  computed: {
    chosenSelectors() {
      return this.allSelectors.filter((e) => this.chosenSelectorMap[e.id] || !1);
    },
    availableSelectors() {
      return this.allSelectors.filter(
        (e) => !this.chosenSelectorMap[e.id] && e.valid || !1
      );
    },
    chosenSiblings() {
      return this.siblingSelectors.filter((e) => this.chosenSiblingMap[e.id] || !1);
    },
    availableSiblings() {
      return this.siblingSelectors.filter(
        (e) => !this.chosenSiblingMap[e.id] && e.valid || !1
      );
    },
    selectorNodeRule() {
      return this.chosenSelectors.length === 0 ? "" : (this.chosenSiblings.length ? `${this.chosenSiblings.reduce((t, r) => `${t}${r.value}`, "")} + ` : "") + this.chosenSelectors.reduce((t, r) => `${t}${r.value}`, "");
    }
  },
  watch: {
    selectors: {
      handler(e) {
        this.allSelectors = da(e), this.shadowNode && this.allSelectors.forEach((t) => {
          t.category === "tag" && (this.chosenSelectorMap[t.id] = !0);
        }), Object.keys(this.chosenSelectorMap).length === 0 && this.allSelectors.forEach((t) => {
          this.chosenSelectorMap[t.id] = t.chosen;
        }), this.$emit("update-selector-node", { id: this.id, nodeRule: this.selectorNodeRule });
      },
      immediate: !0
    },
    siblings: {
      handler(e) {
        this.siblingSelectors = da(e), Object.keys(this.chosenSiblingMap).length === 0 && this.siblingSelectors.forEach((t) => {
          this.chosenSiblingMap[t.id] = t.chosen;
        }), this.$emit("update-selector-node", { id: this.id, nodeRule: this.selectorNodeRule });
      },
      immediate: !0
    }
  },
  created() {
    this.chosenSelectors.length === 0 && this.siblingSelectors.forEach((e) => {
      e.chosen = !1, e.clickable = !1;
    });
  },
  methods: {
    onSelectorClick(e) {
      const t = this.allSelectors.findIndex(
        (n) => n.category === e.category && n.defaultValue === e.defaultValue
      ), r = this.allSelectors[t];
      this.chosenSelectorMap[r.id] = r.valid && !this.chosenSelectorMap[r.id], this.$nextTick(() => {
        const n = this.$refs[r.id];
        Ae(n) || n[0].$el.focus();
      }), this.chosenSelectors.length === 0 ? this.siblingSelectors.forEach((n) => {
        this.chosenSiblingMap[n.id] = !1, n.clickable = !1;
      }) : this.siblingSelectors.forEach((n) => {
        n.clickable = !0;
      }), this.$emit("update-selector-node", { id: this.id, nodeRule: this.selectorNodeRule });
    },
    onSiblingClick(e) {
      const t = this.siblingSelectors, r = this.siblingSelectors.findIndex(
        (s) => s.category === e.category && s.defaultValue === e.defaultValue
      ), n = t[r];
      this.chosenSiblingMap[n.id] = n.valid && !this.chosenSiblingMap[n.id], this.$nextTick(() => {
        const s = this.$refs[n.id];
        s && s[0].$el.focus();
      }), this.$emit("update-selector-node", { id: this.id, nodeRule: this.selectorNodeRule });
    }
  }
}, fo = { class: "crb-selector-node" }, ho = ["tabindex"], po = {
  key: 0,
  class: "crb-selector-node__empty"
}, go = {
  key: 0,
  id: "plus"
}, _o = {
  key: 1,
  class: "crb-selector-node__unavailable"
}, bo = {
  key: 2,
  tabindex: "0",
  "aria-expanded": "true",
  class: "crb-selector-node__active"
}, mo = { class: "crb-selector-node__selected" }, vo = {
  key: 0,
  class: "empty-node"
}, yo = {
  key: 1,
  class: "chosen-selectors"
}, xo = {
  key: 0,
  id: "plus"
}, So = { class: "crb-selector-node__available" }, Co = {
  key: 0,
  class: "empty-node"
}, wo = {
  key: 1,
  class: "available-selectors"
}, Eo = {
  key: 0,
  class: "selector-label"
}, Ro = {
  key: 1,
  class: "selector-label"
};
function Ao(e, t, r, n, s, a) {
  const i = x("selector-button");
  return d(), p("div", fo, [
    r.active ? a.chosenSelectors.length === 0 && a.availableSelectors.length === 0 ? (d(), p("div", _o, " All possible selectors have been marked as unavailable. Please update your settings. ")) : (d(), p("div", bo, [
      g("div", mo, [
        a.chosenSelectors.length === 0 && a.chosenSiblings.length === 0 ? (d(), p("div", vo)) : (d(), p("div", yo, [
          (d(!0), p(K, null, H(a.chosenSiblings, (l) => (d(), M(i, {
            id: l.id,
            ref_for: !0,
            ref: l.id,
            key: l.id,
            class: $({ invalid: !l.valid }),
            category: l.category,
            value: l.value,
            "default-value": l.defaultValue,
            clickable: l.clickable,
            closable: !0,
            configurable: r.configurable,
            "edit-style": l.editStyle,
            "is-node-active": r.active,
            onClick: a.onSiblingClick
          }, null, 8, ["id", "class", "category", "value", "default-value", "clickable", "configurable", "edit-style", "is-node-active", "onClick"]))), 128)),
          a.chosenSiblings.length ? (d(), p("p", xo, " + ")) : O("", !0),
          (d(!0), p(K, null, H(a.chosenSelectors, (l) => (d(), M(i, {
            id: l.id,
            ref_for: !0,
            ref: l.id,
            key: l.id,
            class: $({ invalid: !l.valid }),
            category: l.category,
            value: l.value,
            "default-value": l.defaultValue,
            clickable: !(r.shadowNode && l.category === "tag"),
            closable: !(r.shadowNode && l.category === "tag"),
            configurable: r.configurable,
            "is-node-active": r.active,
            "edit-style": l.editStyle,
            onClick: a.onSelectorClick
          }, null, 8, ["id", "class", "category", "value", "default-value", "clickable", "closable", "configurable", "is-node-active", "edit-style", "onClick"]))), 128))
        ]))
      ]),
      g("div", So, [
        a.availableSelectors.length === 0 && a.availableSiblings.length === 0 ? (d(), p("div", Co)) : (d(), p("div", wo, [
          t[0] || (t[0] = g("p", { id: "choose" }, " Choose from below to add to rule: ", -1)),
          a.availableSiblings.length ? (d(), p("p", Eo, " Sibling Selectors ")) : O("", !0),
          (d(!0), p(K, null, H(a.availableSiblings, (l) => (d(), M(i, {
            id: l.id,
            ref_for: !0,
            ref: l.id,
            key: l.id,
            class: $({ invalid: !l.valid }),
            category: l.category,
            value: l.value,
            "default-value": l.defaultValue,
            clickable: l.clickable,
            closable: !1,
            configurable: r.configurable,
            "is-node-active": r.active,
            "edit-style": l.editStyle,
            onClick: a.onSiblingClick
          }, null, 8, ["id", "class", "category", "value", "default-value", "clickable", "configurable", "is-node-active", "edit-style", "onClick"]))), 128)),
          a.availableSelectors.length ? (d(), p("p", Ro, " Selectors ")) : O("", !0),
          (d(!0), p(K, null, H(a.availableSelectors, (l) => (d(), M(i, {
            id: l.id,
            ref_for: !0,
            ref: l.id,
            key: l.id,
            class: $({ invalid: !l.valid }),
            category: l.category,
            value: l.value,
            "default-value": l.defaultValue,
            clickable: !0,
            closable: !1,
            configurable: r.configurable,
            "is-node-active": r.active,
            "edit-style": l.editStyle,
            onClick: a.onSelectorClick
          }, null, 8, ["id", "class", "category", "value", "default-value", "configurable", "is-node-active", "edit-style", "onClick"]))), 128))
        ]))
      ])
    ])) : (d(), p("div", {
      key: 0,
      "aria-expanded": "false",
      tabindex: `${a.chosenSelectors.length ? "0" : "-1"}`,
      class: "crb-selector-node__inactive"
    }, [
      a.chosenSelectors.length === 0 && r.showUnusedNodes ? (d(), p("div", po)) : O("", !0),
      g("div", {
        class: $(a.chosenSelectors.length === 0 ? "" : "chosen-selectors")
      }, [
        (d(!0), p(K, null, H(a.chosenSiblings, (l) => (d(), M(i, {
          id: l.id,
          key: l.id,
          class: $({ invalid: !l.valid }),
          category: l.category,
          "default-value": l.defaultValue,
          value: l.value,
          clickable: !1,
          closable: !0,
          configurable: r.configurable,
          "is-node-active": r.active,
          "edit-style": l.editStyle
        }, null, 8, ["id", "class", "category", "default-value", "value", "configurable", "is-node-active", "edit-style"]))), 128)),
        a.chosenSiblings.length ? (d(), p("p", go, " + ")) : O("", !0),
        (d(!0), p(K, null, H(a.chosenSelectors, (l) => (d(), M(i, {
          id: l.id,
          key: l.id,
          class: $({ invalid: !l.valid }),
          value: l.value,
          category: l.category,
          "default-value": l.defaultValue,
          clickable: !1,
          configurable: r.configurable,
          "is-node-active": r.active,
          "edit-style": l.editStyle,
          closable: !0
        }, null, 8, ["id", "class", "value", "category", "default-value", "configurable", "is-node-active", "edit-style"]))), 128))
      ], 2)
    ], 8, ho))
  ]);
}
const To = /* @__PURE__ */ F(co, [["render", Ao], ["__scopeId", "data-v-9b9e3362"]]), qo = {
  name: "CustomRuleSelect",
  components: { SelectorNode: To },
  props: {
    selectorNodes: {
      default: () => [],
      type: Array
    },
    showUnusedNodes: {
      default: !1,
      type: Boolean
    },
    configurable: {
      default: !1,
      type: Boolean
    }
  },
  emits: ["changed-rule"],
  data() {
    return {
      selectorNodeRules: {},
      selectorNodePrevIds: {},
      selectorNodeShadows: {},
      activeNodeIdx: 0
    };
  },
  computed: {
    ruleEntries() {
      return Object.entries(this.selectorNodeRules);
    },
    numUnusedSelectorNodes() {
      return this.ruleEntries.filter((e) => e[1] === "").length;
    },
    currentRule() {
      let e = "";
      for (const [t, r] of this.ruleEntries)
        if (r !== "") {
          const n = this.selectorNodePrevIds[t];
          (this.selectorNodeRules[n] === void 0 ? "" : this.selectorNodeRules[n]) !== "" ? e = `${e} > ${r}` : e = `${e} ${r}`, this.selectorNodeShadows[t] && (e = `${e}::shadow`);
        }
      return e.trim();
    }
  },
  watch: {
    selectorNodes: {
      handler(e) {
        this.selectoreNodePrevIds = {};
        let t = "";
        this.selectorNodeRules = {};
        for (const r of e)
          this.selectorNodePrevIds[r.id] = t, this.selectorNodeShadows[r.id] = r.shadow, t = r.id;
      },
      immediate: !0
    }
  },
  created() {
    this.activeNodeIdx = this.selectorNodes.length - 1;
  },
  methods: {
    decrementActiveNode() {
      let e = this.activeNodeIdx - 1;
      for (; e >= 0 && this.ruleEntries[e][1] === ""; )
        e--;
      e >= 0 && this.updateActiveNode(e);
    },
    incrementActiveNode() {
      let e = this.activeNodeIdx + 1;
      for (; e < this.ruleEntries.length && this.ruleEntries[e][1] === ""; )
        e++;
      e < this.ruleEntries.length && this.updateActiveNode(e);
    },
    updateActiveNode(e) {
      this.activeNodeIdx = e, this.$nextTick(() => {
        this.$refs.nodes[e].$el.focus();
      });
    },
    selectorNodeChange(e) {
      this.selectorNodeRules[e.id] = e.nodeRule, this.ruleEntries.length === this.selectorNodes.length && this.$emit("changed-rule", { currentRule: this.currentRule, numUnused: this.numUnusedSelectorNodes });
    }
  }
};
function Io(e, t, r, n, s, a) {
  const i = x("selector-node");
  return d(), p("div", null, [
    (d(!0), p(K, null, H(r.selectorNodes, (l, o) => (d(), M(i, {
      id: l.id,
      key: l.id,
      ref_for: !0,
      ref: "nodes",
      configurable: r.configurable,
      class: "crb-custom-rule-select__row",
      selectors: l.selectors,
      siblings: l.siblings,
      active: o === s.activeNodeIdx,
      "show-unused-nodes": r.showUnusedNodes,
      "shadow-node": l.shadow,
      onUpdateSelectorNode: a.selectorNodeChange,
      onKeyup: [
        Br(a.decrementActiveNode, ["up"]),
        Br(a.incrementActiveNode, ["down"])
      ],
      onClick: (u) => a.updateActiveNode(o)
    }, null, 8, ["id", "configurable", "selectors", "siblings", "active", "show-unused-nodes", "shadow-node", "onUpdateSelectorNode", "onKeyup", "onClick"]))), 128))
  ]);
}
const ko = /* @__PURE__ */ F(qo, [["render", Io], ["__scopeId", "data-v-ea93c915"]]);
var Ut, fa;
function Oo() {
  if (fa) return Ut;
  fa = 1;
  var e = Wi(), t = be(), r = "[object RegExp]";
  function n(s) {
    return t(s) && e(s) == r;
  }
  return Ut = n, Ut;
}
var Lt, ha;
function No() {
  if (ha) return Lt;
  ha = 1;
  var e = Oo(), t = ke(), r = Xr(), n = r && r.isRegExp, s = n ? t(n) : e;
  return Lt = s, Lt;
}
var Po = No();
const Do = /* @__PURE__ */ Z(Po);
var Mo = fe();
const Uo = /* @__PURE__ */ Z(Mo), pa = "pendo-selection-HL", Lo = "pendo-selection", Vo = "pendo-tagged-HL", $o = "pendo-overlay", Fo = "pendo-tooltip", jo = "pendo-overlay-target", Bo = "pendo-ignore", Wo = [
  pa,
  `orig-${pa}`,
  Lo,
  Vo,
  $o,
  Fo,
  jo,
  Bo,
  // Exclude all the classes generated by Tether
  /^pendo-tether-/,
  // Ignore meaningless classes based on framework...
  // Angular
  "ng-isolate-scope",
  "ng-scope",
  "ng-hide",
  "ng-show",
  "ng-binding",
  // Bootstrap
  "pull-left",
  "pull-right",
  // https://pendo-io.atlassian.net/browse/APP-11337
  /^jss\d+/,
  // Sam's club uses this as part of their "riversand" platform
  /^rs[a-zA-Z0-9]{16}$/,
  // class names can't start with numbers (this is based on the w3c spec)
  // Sizzle doesn't follow the spec, but the backend does, so we can't allow 'em
  /^\d/
], Ko = [
  /ext-gen\d+/,
  /ext-comp-\d+/,
  /x-auto-\d+/,
  /gwt-uid-\d+/,
  /yui-gen\d+/,
  /yui_.*/,
  /^rs[a-zA-Z0-9]{16}$/,
  /ember\d+/
];
class Ho {
  constructor() {
    this.classTagExclusions = [], this.idTagExclusions = [];
  }
  handleWildcards(t) {
    switch (!0) {
      case (le(t) && t.startsWith("*") && t.endsWith("*")):
        return new RegExp(t.slice(1, -1));
      case (le(t) && t.startsWith("*")):
        return new RegExp(`${t.slice(1)}$`);
      case (le(t) && t.endsWith("*")):
        return new RegExp(`^${t.slice(0, -1)}`);
      default:
        return t;
    }
  }
  getExclusions(t, r) {
    return t.map((n) => le(n) ? new RegExp(`^${n}$`, "i") : n).concat(r);
  }
  setExclusions(t) {
    return Uo(t) ? t.map((r) => this.handleWildcards(r)).filter((r) => r !== void 0) : [];
  }
  isExcluded(t, r) {
    return t.find((n) => Do(n) && n.test(r) || le(n) && n === r);
  }
  get classExclusions() {
    return this.getExclusions(Wo, this.classTagExclusions);
  }
  set classExclusions(t) {
    this.classTagExclusions = this.setExclusions(t);
  }
  isExcludedClass(t) {
    return this.isExcluded(this.classExclusions, t);
  }
  get idExclusions() {
    return this.getExclusions(Ko, this.idTagExclusions);
  }
  set idExclusions(t) {
    this.idTagExclusions = this.setExclusions(t);
  }
  isExcludedId(t) {
    return this.isExcluded(this.idExclusions, t);
  }
}
function Vt(e) {
  let t, r, n;
  return e = e.trim(), e && e.length > 0 && e.length < 129 && !/\u00a0/.test(e) ? (t = e.indexOf("'"), r = e.indexOf('"'), t === -1 || r !== -1 && r < t ? n = "'" : n = '"', e = new RegExp(`^[^\\f\\n\\r${n}]+`).exec(e), e ? `:contains(${n}${e[0]}${n})` : "") : "";
}
const ue = new Ho();
function ga(e, t = "") {
  const r = [];
  if (Object.keys(e.attrs).filter((a) => /^_pendo_sibling_/.test(a)).length === 0)
    return r;
  if (e.attrs._pendo_sibling_tag && r.push({
    id: `${t}ss${r.length}`,
    category: "tag",
    value: e.attrs._pendo_sibling_tag.toLowerCase(),
    defaultValue: e.attrs._pendo_sibling_tag.toLowerCase(),
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), e.attrs._pendo_sibling_id && e.attrs._pendo_sibling_id !== "" && !ue.isExcludedId(e.attrs._pendo_sibling_id) && r.push({
    id: `${t}ss${r.length}`,
    category: "id",
    value: `#${e.attrs._pendo_sibling_id}`,
    defaultValue: `#${e.attrs._pendo_sibling_id}`,
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), e.attrs._pendo_sibling_class)
    for (const a of e.attrs._pendo_sibling_class.split(" "))
      a.trim() !== "" && !ue.isExcludedClass(a.trim()) && r.push({
        id: `${t}ss${r.length}`,
        category: "className",
        value: `.${a}`,
        defaultValue: `.${a}`,
        chosen: !1,
        valid: !0,
        editStyle: "Default"
      });
  const s = Object.entries(e.attrs).filter(([a]) => /^_pendo_sibling_attr/.test(a));
  for (const [a, i] of s)
    r.push({
      id: `${t}ss${r.length}`,
      category: "attrib",
      value: `[${a.slice(21)}="${i}"]`,
      defaultValue: `[${a.slice(21)}="${i}"]`,
      chosen: !1,
      valid: !0,
      editStyle: "Default"
    });
  return e.attrs._pendo_sibling_pendo_text && r.push({
    id: `${t}ss${r.length}`,
    category: "contains",
    value: `:contains("${e.attrs._pendo_sibling_pendo_text.trim()}")`,
    defaultValue: `:contains("${e.attrs._pendo_sibling_pendo_text.trim()}")`,
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), r;
}
function _a(e, t = "") {
  const r = [];
  r.push({
    id: `${t}s${r.length}`,
    category: "tag",
    value: e.tag.toLowerCase(),
    defaultValue: e.tag.toLowerCase(),
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), e.id !== "" && !ue.isExcludedId(e.id) && r.push({
    id: `${t}s${r.length}`,
    category: "id",
    value: `#${e.id}`,
    defaultValue: `#${e.id}`,
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  });
  for (const n of e.cls.trim().split(" "))
    n !== "" && n !== " " && !ue.isExcludedClass(n) && r.push({
      id: `${t}s${r.length}`,
      category: "className",
      value: `.${n}`,
      defaultValue: `.${n}`,
      chosen: !1,
      valid: !0,
      editStyle: "Default"
    });
  if (Object.keys(e.attrs).length > 0) {
    for (const [n, s] of Object.entries(e.attrs))
      if (!/^_pendo_sibling_/.test(n)) {
        const a = s ? `="${s}"` : "";
        r.push({
          id: `${t}s${r.length}`,
          category: "attrib",
          value: `[${n}${a}]`,
          defaultValue: `[${n}${a}]`,
          chosen: !1,
          valid: !0,
          editStyle: "Default"
        });
      }
  }
  return e.txt && Vt(e.txt).length > 0 && r.push({
    id: `${t}s${r.length}`,
    category: "contains",
    value: Vt(e.txt),
    defaultValue: Vt(e.txt),
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), r.push({
    id: `${t}s${r.length}`,
    category: "nthChild",
    value: `:nth-child(${e.childIndex + 1})`,
    defaultValue: `:nth-child(${e.childIndex + 1})`,
    chosen: !1,
    valid: !0,
    editStyle: "Default"
  }), r;
}
function Gs(e, t = 0, r = "") {
  if (!e.parentElem)
    return [
      {
        id: `${r}n${t}`,
        selectors: _a(e, `${r}n${t}`),
        siblings: ga(e, `${r}n${t}`),
        shadow: !1
      }
    ];
  const n = Gs(e.parentElem, t + 1, r);
  return n.push({
    id: `${r}n${t}`,
    selectors: _a(e, `${r}n${t}`),
    siblings: ga(e, `${r}n${t}`),
    shadow: !1
  }), n;
}
function zo(e) {
  const t = {
    value: e.content
  };
  let r, n;
  switch (e.name) {
    case "id":
      t.category = "id", r = "^#", n = "$";
      break;
    case "class":
      t.category = "className", r = "^\\.", n = "$";
      break;
    default:
      t.category = "attrib", r = `^\\[${e.name}=['\\"]`, n = `['\\"]\\]$`;
      break;
  }
  if (!e.operator)
    t.regex = new RegExp(`${r}.*`), t.editStyle = "Attribute Exists";
  else {
    let s = e.value.replace(/^(['\\"])(.*)(['\\"])$/, "$2");
    switch (e.operator) {
      case "^=":
        s = `${s}.*`, t.editStyle = "Starts With";
        break;
      case "$=":
        s = `.*${s}`, t.editStyle = "Ends With";
        break;
      case "*=":
        s = `.*${s}.*`, t.editStyle = "Contains";
        break;
      default:
        t.editStyle = "Default";
        break;
    }
    t.regex = new RegExp(`${r}${s}${n}`);
  }
  return t;
}
function Go(e) {
  let t = { shadow: !1, selectors: [], siblings: [] }, r = [], n = "selectors";
  const s = [];
  return e.reverse().forEach((a) => {
    switch (a.type) {
      case "type":
        t[n].push({
          category: "tag",
          value: a.content
        });
        break;
      case "id":
        t[n].push({
          category: "id",
          value: a.content
        });
        break;
      case "class":
        t[n].push({
          category: "className",
          value: a.content
        });
        break;
      case "attribute":
        t[n].push(zo(a));
        break;
      case "pseudo-class":
        if (a.name === "contains" || a.name === "nth-child") {
          const i = a.name.replace(/-./g, (l) => l[1].toUpperCase());
          t[n].push({
            category: i,
            value: a.content
          });
        }
        break;
      case "pseudo-element":
        a.name === "shadow" && (t.shadow = !0);
        break;
      case "combinator":
        a.content === "+" ? n = "siblings" : (n = "selectors", r.unshift(t), t = { selectors: [], siblings: [] }, a.content === " " && (s.push(
          r.reduce((i, l) => i === null ? { ...l, ruleDepth: 1 } : { ...l, ruleDepth: i.ruleDepth + 1, parent: i }, null)
        ), r = []));
        break;
    }
  }), r.unshift(t), s.push(
    r.reduce((a, i) => a === null ? { ...i, ruleDepth: 1 } : { ...i, ruleDepth: a.ruleDepth + 1, parent: a }, null)
  ), s;
}
function Zo(e) {
  const t = Ps(e);
  return Go(t);
}
function Yo(e, t, r = !1) {
  if (e.regex) {
    const n = e.regex.test(t.defaultValue);
    return r && n && (t.value = e.value, t.editStyle = e.editStyle), n;
  }
  return t.category === e.category && t.value === e.value;
}
function Zs(e, t, r, n, s, a, i) {
  return e[t][s](
    (l) => n[r][t][a]((o) => Yo(l, o, i))
  );
}
function ba(e, t, r, n) {
  return Zs(e, t, r, n, "every", "some", !1);
}
function Ys(e, t, r) {
  return ba(e, "selectors", t, r) && ba(e, "siblings", t, r) && (!e.parent || Ys(e.parent, t - 1, r));
}
function we(e, t, r, n) {
  return Zs(e, t, r, n, "map", "findIndex", !0);
}
function Jo(e, t, r = "") {
  const n = Gs(e, 0, r), s = Zo(t);
  let a = n.length - 1, i;
  const l = [], o = [];
  let u = !1;
  for (; a >= 0 && s.length > 0; ) {
    if (i = s.shift(), a < i.ruleDepth - 1) {
      u = !0;
      break;
    }
    for (; !Ys(i, a, n); )
      if (a--, a < i.ruleDepth - 1) {
        u = !0;
        break;
      }
    for (; i.parent; )
      n[a].shadow = i.shadow, l[a] = we(
        i,
        "selectors",
        a,
        n
      ), o[a] = we(i, "siblings", a, n), i = i.parent, a--;
    n[a].shadow = i.shadow, l[a] = we(i, "selectors", a, n), o[a] = we(i, "siblings", a, n), a--;
  }
  return u || (l.forEach((c, f) => {
    c !== null && c.forEach((h) => {
      n[f].selectors[h].chosen = !0;
    });
  }), o.forEach((c, f) => {
    c !== null && c.forEach((h) => {
      n[f].siblings[h].chosen = !0;
    });
  })), n;
}
function Xo(e = [], t = []) {
  ue.classExclusions = e, ue.idExclusions = t;
}
function Qo(e, t) {
  const r = t.id.split("s", 1)[0], n = t.id.includes("ss") ? "siblings" : "selectors", s = e.findIndex((a) => a.id === r);
  if (e[s]) {
    const a = e[s][n].findIndex(
      (l) => l.id === t.id
    ), i = e[s][n][a];
    e[s][n].splice(a, 1, {
      ...i,
      value: t.value,
      editStyle: t.editStyle,
      chosen: !0
    });
  }
  return e;
}
const eu = {
  name: "CustomRuleBuilder",
  components: {
    CustomRuleSelect: ko,
    PendoToggle: Ss
  },
  props: {
    nodePrefix: {
      default: "",
      type: String
    },
    customRule: {
      default: "",
      type: String
    },
    target: {
      default: () => {
      },
      type: Object
    },
    classExclusions: {
      default: () => [],
      type: Array
    },
    idExclusions: {
      default: () => [],
      type: Array
    },
    numMatches: {
      default: 0,
      type: Number
    },
    configurable: {
      default: !1,
      type: Boolean
    }
  },
  data() {
    return {
      currentRule: "",
      selectorNodes: [],
      showUnusedNodes: !1,
      numUnused: 0
    };
  },
  computed: {
    numUnusedLabel() {
      return this.numUnused === 1 ? "Show 1 unused node" : `Show ${this.numUnused} unused nodes`;
    }
  },
  watch: {
    customRule: {
      handler(e) {
        this.refreshSelectorNodeData(this.target, e), this.customRuleSelectChange({ currentRule: e });
      },
      immediate: !0
    },
    target(e) {
      this.refreshSelectorNodeData(e, this.customRule);
    }
  },
  mounted() {
    V.$on("apply-click", (e) => {
      this.selectorNodes = Qo(this.selectorNodes, e);
    });
  },
  methods: {
    refreshSelectorNodeData(e, t) {
      Xo(this.classExclusions, this.idExclusions), this.selectorNodes = Jo(e, t, this.nodePrefix);
    },
    customRuleSelectChange(e) {
      this.numUnused = e.numUnused, this.currentRule !== e.currentRule && (this.currentRule = e.currentRule, this.$emit("changed-rule", this.currentRule));
    },
    updateUnusedNodeVisibility() {
      this.showUnusedNodes = !this.showUnusedNodes;
    }
  }
}, tu = { class: "crb-bottom" }, ru = { class: "crb-matches" };
function nu(e, t, r, n, s, a) {
  const i = x("custom-rule-select"), l = x("pendo-toggle");
  return d(), p("div", null, [
    m(i, {
      class: "crb-custom-select",
      "selector-nodes": s.selectorNodes,
      configurable: r.configurable,
      "show-unused-nodes": s.showUnusedNodes,
      onChangedRule: a.customRuleSelectChange
    }, null, 8, ["selector-nodes", "configurable", "show-unused-nodes", "onChangedRule"]),
    g("div", tu, [
      g("p", ru, U(r.numMatches === 1 ? `${r.numMatches} match found` : `${r.numMatches} matches found`), 1),
      m(l, {
        class: "crb-toggle",
        value: s.showUnusedNodes,
        "label-position": "left",
        label: a.numUnusedLabel,
        onChange: a.updateUnusedNodeVisibility
      }, null, 8, ["value", "label", "onChange"])
    ])
  ]);
}
const Js = /* @__PURE__ */ F(eu, [["render", nu], ["__scopeId", "data-v-5babfc71"]]);
var $t, ma;
function au() {
  if (ma) return $t;
  ma = 1;
  function e(t, r, n, s) {
    var a = -1, i = t == null ? 0 : t.length;
    for (s && i && (n = t[++a]); ++a < i; )
      n = r(n, t[a], a, t);
    return n;
  }
  return $t = e, $t;
}
var Ft, va;
function su() {
  if (va) return Ft;
  va = 1;
  function e(t) {
    return function(r) {
      return t == null ? void 0 : t[r];
    };
  }
  return Ft = e, Ft;
}
var jt, ya;
function iu() {
  if (ya) return jt;
  ya = 1;
  var e = su(), t = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, r = e(t);
  return jt = r, jt;
}
var Bt, xa;
function lu() {
  if (xa) return Bt;
  xa = 1;
  var e = iu(), t = _e(), r = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, n = "\\u0300-\\u036f", s = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", i = n + s + a, l = "[" + i + "]", o = RegExp(l, "g");
  function u(c) {
    return c = t(c), c && c.replace(r, e).replace(o, "");
  }
  return Bt = u, Bt;
}
var Wt, Sa;
function ou() {
  if (Sa) return Wt;
  Sa = 1;
  var e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function t(r) {
    return r.match(e) || [];
  }
  return Wt = t, Wt;
}
var Kt, Ca;
function uu() {
  if (Ca) return Kt;
  Ca = 1;
  var e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function t(r) {
    return e.test(r);
  }
  return Kt = t, Kt;
}
var Ht, wa;
function cu() {
  if (wa) return Ht;
  wa = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", s = t + r + n, a = "\\u2700-\\u27bf", i = "a-z\\xdf-\\xf6\\xf8-\\xff", l = "\\xac\\xb1\\xd7\\xf7", o = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", u = "\\u2000-\\u206f", c = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", f = "A-Z\\xc0-\\xd6\\xd8-\\xde", h = "\\ufe0e\\ufe0f", b = l + o + u + c, R = "['’]", _ = "[" + b + "]", v = "[" + s + "]", C = "\\d+", y = "[" + a + "]", T = "[" + i + "]", S = "[^" + e + b + C + a + i + f + "]", N = "\\ud83c[\\udffb-\\udfff]", E = "(?:" + v + "|" + N + ")", w = "[^" + e + "]", P = "(?:\\ud83c[\\udde6-\\uddff]){2}", q = "[\\ud800-\\udbff][\\udc00-\\udfff]", D = "[" + f + "]", B = "\\u200d", L = "(?:" + T + "|" + S + ")", W = "(?:" + D + "|" + S + ")", z = "(?:" + R + "(?:d|ll|m|re|s|t|ve))?", G = "(?:" + R + "(?:D|LL|M|RE|S|T|VE))?", ne = E + "?", me = "[" + h + "]?", ve = "(?:" + B + "(?:" + [w, P, q].join("|") + ")" + me + ne + ")*", Ne = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", De = me + ne + ve, Me = "(?:" + [y, P, q].join("|") + ")" + De, Ue = RegExp([
    D + "?" + T + "+" + z + "(?=" + [_, D, "$"].join("|") + ")",
    W + "+" + G + "(?=" + [_, D + L, "$"].join("|") + ")",
    D + "?" + L + "+" + z,
    D + "+" + G,
    Pe,
    Ne,
    C,
    Me
  ].join("|"), "g");
  function Le(Ve) {
    return Ve.match(Ue) || [];
  }
  return Ht = Le, Ht;
}
var zt, Ea;
function du() {
  if (Ea) return zt;
  Ea = 1;
  var e = ou(), t = uu(), r = _e(), n = cu();
  function s(a, i, l) {
    return a = r(a), i = l ? void 0 : i, i === void 0 ? t(a) ? n(a) : e(a) : a.match(i) || [];
  }
  return zt = s, zt;
}
var Gt, Ra;
function fu() {
  if (Ra) return Gt;
  Ra = 1;
  var e = au(), t = lu(), r = du(), n = "['’]", s = RegExp(n, "g");
  function a(i) {
    return function(l) {
      return e(r(t(l).replace(s, "")), i, "");
    };
  }
  return Gt = a, Gt;
}
var Zt, Aa;
function hu() {
  if (Aa) return Zt;
  Aa = 1;
  function e(t, r, n) {
    var s = -1, a = t.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var i = Array(a); ++s < a; )
      i[s] = t[s + r];
    return i;
  }
  return Zt = e, Zt;
}
var Yt, Ta;
function Xs() {
  if (Ta) return Yt;
  Ta = 1;
  var e = hu();
  function t(r, n, s) {
    var a = r.length;
    return s = s === void 0 ? a : s, !n && s >= a ? r : e(r, n, s);
  }
  return Yt = t, Yt;
}
var Jt, qa;
function Qs() {
  if (qa) return Jt;
  qa = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", s = t + r + n, a = "\\ufe0e\\ufe0f", i = "\\u200d", l = RegExp("[" + i + e + s + a + "]");
  function o(u) {
    return l.test(u);
  }
  return Jt = o, Jt;
}
var Xt, Ia;
function pu() {
  if (Ia) return Xt;
  Ia = 1;
  function e(t) {
    return t.split("");
  }
  return Xt = e, Xt;
}
var Qt, ka;
function gu() {
  if (ka) return Qt;
  ka = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", s = t + r + n, a = "\\ufe0e\\ufe0f", i = "[" + e + "]", l = "[" + s + "]", o = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + l + "|" + o + ")", c = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", b = "\\u200d", R = u + "?", _ = "[" + a + "]?", v = "(?:" + b + "(?:" + [c, f, h].join("|") + ")" + _ + R + ")*", C = _ + R + v, y = "(?:" + [c + l + "?", l, f, h, i].join("|") + ")", T = RegExp(o + "(?=" + o + ")|" + y + C, "g");
  function S(N) {
    return N.match(T) || [];
  }
  return Qt = S, Qt;
}
var er, Oa;
function ei() {
  if (Oa) return er;
  Oa = 1;
  var e = pu(), t = Qs(), r = gu();
  function n(s) {
    return t(s) ? r(s) : e(s);
  }
  return er = n, er;
}
var tr, Na;
function _u() {
  if (Na) return tr;
  Na = 1;
  var e = Xs(), t = Qs(), r = ei(), n = _e();
  function s(a) {
    return function(i) {
      i = n(i);
      var l = t(i) ? r(i) : void 0, o = l ? l[0] : i.charAt(0), u = l ? e(l, 1).join("") : i.slice(1);
      return o[a]() + u;
    };
  }
  return tr = s, tr;
}
var rr, Pa;
function bu() {
  if (Pa) return rr;
  Pa = 1;
  var e = _u(), t = e("toUpperCase");
  return rr = t, rr;
}
var nr, Da;
function mu() {
  if (Da) return nr;
  Da = 1;
  var e = fu(), t = bu(), r = e(function(n, s, a) {
    return n + (a ? " " : "") + t(s);
  });
  return nr = r, nr;
}
var vu = mu();
const ti = /* @__PURE__ */ Z(vu), yu = {
  name: "FeaturesButton",
  components: {
    PendoIcon: ge,
    PendoLoadingIndicator: Ii
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    countColor: {
      type: String,
      required: !0
    },
    countBackgroundColor: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    countStyles() {
      return {
        color: `${this.countColor}`,
        backgroundColor: `${this.countBackgroundColor}`
      };
    },
    tooltipLabel() {
      return `${ti(this.type)} are loading.`;
    }
  },
  methods: {
    emitClick() {
      !this.loading && !this.disabled && this.$emit("onNavigationClick");
    }
  }
}, xu = { class: "features-button--start" }, Su = { key: 1 }, Cu = { class: "features-button--start-labels" }, wu = { class: "features-button--start-labels-type" }, Eu = { class: "features-button--start-labels-description" }, Ru = { class: "features-button--end" };
function Au(e, t, r, n, s, a) {
  const i = x("pendo-loading-indicator"), l = x("pendo-icon"), o = de("pendo-tooltip");
  return re((d(), p("div", {
    class: $(["features-button", {
      disabled: r.loading || r.disabled
    }]),
    onClick: t[0] || (t[0] = (...u) => a.emitClick && a.emitClick(...u))
  }, [
    g("div", xu, [
      g("div", {
        class: "features-button--start-count",
        style: Hr(a.countStyles)
      }, [
        r.loading ? (d(), M(i, {
          key: 0,
          size: "small"
        })) : (d(), p("span", Su, U(r.count), 1))
      ], 4),
      g("div", Cu, [
        g("div", wu, U(r.type), 1),
        g("div", Eu, U(r.description), 1)
      ])
    ]),
    g("div", Ru, [
      r.disabled ? O("", !0) : (d(), M(l, {
        key: 0,
        type: "chevron-right",
        size: "16",
        stroke: "#2A2C35"
      }))
    ])
  ], 2)), [
    [o, {
      arrow: !0,
      content: r.loading ? a.tooltipLabel : null,
      boundariesElement: "viewport",
      delay: { show: 300, hide: 0 },
      multiline: !0
    }]
  ]);
}
const ri = /* @__PURE__ */ F(yu, [["render", Au]]), Tu = {
  name: "PageRuleTester",
  components: {
    PendoModal: Kr,
    PendoForm: Es,
    PendoFormItem: ws,
    PendoButton: X,
    PendoInput: Cs,
    PendoAlert: ki
  },
  props: {
    visible: {
      type: Boolean,
      required: !0
    },
    /**
     * wrapper for `@pendo/http` client
     * client.http.post()
     */
    client: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      default: "Save Rule"
    },
    /**
     * @typedef {Object} ruleObj
     * @property {string} rule - The rule property of the rule object. A page rule like: `//*` or `//about`.
     * @property {string} ruleType - The ruleType property of the rule object. Either "exclude" or "include".
     */
    ruleObj: {
      type: Object,
      required: !0
    },
    showNormalization: {
      type: Boolean,
      default: !1
    },
    pageRules: {
      type: Object,
      default: () => ({ rules: [], excludeRules: [] })
    }
  },
  data() {
    return {
      form: {
        url: "",
        urlNormalize: "",
        rule: ""
      },
      rules: {
        url: [
          {
            required: !0,
            message: "required",
            trigger: "blur"
          },
          {
            validator: this.validateUrl,
            trigger: ["blur", "change"]
          }
        ],
        rule: [
          {
            required: !0,
            message: "required",
            trigger: "blur"
          },
          {
            validator: this.validateRule,
            trigger: ["blur", "change"]
          }
        ]
      },
      isMatch: !1,
      isFormValid: !1
    };
  },
  computed: {
    ruleChanged() {
      return this.form.rule !== this.ruleObj.rule;
    },
    duplicateRules() {
      const e = [], t = this.form.rule, r = this.ruleObj.type;
      if (!r)
        return e;
      const n = r === "exclude" ? this.pageRules.includeRules : this.pageRules.excludeRules;
      return n && n.length && n.forEach((s) => {
        if (s.rule === t) {
          const a = r === "exclude" ? "include" : "exclude";
          e.push({ type: a, rule: s.rule });
        }
      }), e;
    }
  },
  watch: {
    visible(e) {
      e && (this.resetModal(), this.form.rule = this.ruleObj.rule, this.sendTrackEventOpen({ superUser: this.showNormalization, ruleIn: this.ruleObj.rule }), setTimeout(() => {
        this.validateForm();
      }, 1e3));
    }
  },
  methods: {
    close() {
      this.$emit("close", this.ruleObj.rule), this.resetModal();
    },
    save() {
      this.$emit("close", this.form.rule), this.sendTrackEventUpdate({
        superUser: this.showNormalization,
        ruleIn: this.ruleObj.rule,
        ruleOut: this.form.rule,
        isFormValid: this.isFormValid
      }), this.resetModal();
    },
    async validateUrl(e, t, r) {
      const s = new RegExp("^https?://").test(this.form.url) ? this.form.url : `https://${this.form.url}`;
      try {
        const a = await this.client.http.post("/api/s/_SID_/helper/urlnorm", { url: s });
        this.form.urlNormalize = a.data, r();
        return;
      } catch {
        r(new Error("Incorrect URL"));
      }
      this.form.urlNormalize = "";
    },
    async validateRule(e, t, r) {
      const n = new RegExp("^//.*", "gm");
      this.form.rule = this.form.rule.trim();
      let s = n.test(this.form.rule);
      if (!s) {
        r(new Error("Rule must start with //"));
        return;
      }
      const a = await this.client.http.post("/api/s/_SID_/helper/urlpatternparse", {
        urlPattern: this.form.rule
      });
      if (s = new RegExp(a.data.urlRegex).test(this.form.urlNormalize), s) {
        r(), this.isMatch = !0;
        return;
      }
      r(new Error("Rule does not match.")), this.isMatch = !1;
    },
    validateForm() {
      this.$refs.form && this.$refs.form.validate(() => {
      });
    },
    resetModal() {
      this.form.url = "", this.form.urlNormalize = "", this.form.rule = "", this.isMatch = !1, this.formIsValid = !1;
    },
    sendTrackEventOpen({ superUser: e = !1, ruleIn: t = "" }) {
      window.pendo && window.pendo.track("pageRuleTestModalOpen", {
        superUser: e,
        ruleIn: t
      });
    },
    sendTrackEventUpdate({ superUser: e = !1, ruleIn: t = "", ruleOut: r = "", isFormValid: n = !1 }) {
      window.pendo && window.pendo.track("pageRuleTestModalUpdate", {
        superUser: e,
        ruleIn: t,
        ruleOut: r,
        isFormValid: n
      });
    }
  }
}, qu = {
  key: 0,
  class: "page-rule-tester-body-rule-status-success"
}, Iu = {
  key: 1,
  class: "page-rule-tester-body-rule-status-error"
};
function ku(e, t, r, n, s, a) {
  const i = x("pendo-input"), l = x("pendo-form-item"), o = x("pendo-form"), u = x("pendo-alert"), c = x("pendo-button"), f = x("pendo-modal");
  return d(), M(f, {
    title: "Test Page Rule",
    height: "auto",
    "max-width": "450px",
    "show-close": !1,
    visible: r.visible,
    onClose: a.close
  }, {
    body: I(() => [
      m(o, {
        ref: "form",
        modelValue: s.isFormValid,
        "onUpdate:modelValue": t[3] || (t[3] = (h) => s.isFormValid = h),
        model: s.form,
        class: "page-rule-tester--body"
      }, {
        default: I(() => [
          m(l, {
            prop: "url",
            rules: s.rules.url
          }, {
            default: I(() => [
              m(i, {
                modelValue: s.form.url,
                "onUpdate:modelValue": t[0] || (t[0] = (h) => s.form.url = h),
                label: "Test URL",
                debounce: 1e3,
                onInput: a.validateForm
              }, null, 8, ["modelValue", "onInput"])
            ], void 0, !0),
            _: 1
          }, 8, ["rules"]),
          r.showNormalization ? (d(), M(l, { key: 0 }, {
            default: I(() => [
              m(i, {
                modelValue: s.form.urlNormalize,
                "onUpdate:modelValue": t[1] || (t[1] = (h) => s.form.urlNormalize = h),
                readonly: "",
                label: "Normalized Test URL"
              }, null, 8, ["modelValue"])
            ], void 0, !0),
            _: 1
          })) : O("", !0),
          m(l, {
            prop: "rule",
            rules: s.rules.rule
          }, {
            default: I(() => [
              m(i, {
                modelValue: s.form.rule,
                "onUpdate:modelValue": t[2] || (t[2] = (h) => s.form.rule = h),
                label: "Rule",
                debounce: 1e3
              }, null, 8, ["modelValue"]),
              s.isMatch ? (d(), p("div", qu, t[4] || (t[4] = [
                g("i", {
                  class: "fa fa-check",
                  "aria-hidden": "true"
                }, null, -1),
                ee(" URL matches the page rule! ")
              ]))) : O("", !0),
              s.isMatch ? O("", !0) : (d(), p("div", Iu, t[5] || (t[5] = [
                g("a", {
                  href: "https://support.pendo.io/hc/en-us/articles/360032293371-Understanding-URLs-for-page-tagging",
                  target: "_blank"
                }, " Need help? ", -1)
              ])))
            ], void 0, !0),
            _: 1
          }, 8, ["rules"])
        ], void 0, !0),
        _: 1
      }, 8, ["modelValue", "model"]),
      a.duplicateRules.length ? (d(), M(u, {
        key: 0,
        type: "error",
        title: "Error with Tested Rule"
      }, {
        default: I(() => [
          (d(!0), p(K, null, H(a.duplicateRules, (h, b) => (d(), p("div", { key: b }, " Conflicting " + U(h.type) + " rule " + U(h.rule) + ". Exclude Rules cannot match include Rules. ", 1))), 128))
        ], void 0, !0),
        _: 1
      })) : O("", !0)
    ]),
    footer: I(() => [
      m(c, {
        label: `${a.ruleChanged ? "Cancel" : "Done"}`,
        type: "secondary",
        onClick: a.close
      }, null, 8, ["label", "onClick"]),
      a.ruleChanged ? (d(), M(c, {
        key: 0,
        disabled: !!a.duplicateRules.length,
        theme: "app",
        label: r.label,
        onClick: a.save
      }, null, 8, ["disabled", "label", "onClick"])) : O("", !0)
    ]),
    _: 1
  }, 8, ["visible", "onClose"]);
}
const ni = /* @__PURE__ */ F(Tu, [["render", ku], ["__scopeId", "data-v-3380bf32"]]), Ou = {
  name: "PagesButton",
  components: {
    PendoIcon: ge,
    PendoTag: Oi
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    type: {
      type: String,
      default: "Frame"
    },
    activeUrl: {
      type: String,
      default: ""
    },
    tagged: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    hasIncludeOrExcludePages: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    displayUrl() {
      if (this.activeUrl)
        return this.activeUrl.replace(/https?:\/\//, "");
    }
  },
  methods: {
    emitClick() {
      this.disabled || (this.tagged || this.hasIncludeOrExcludePages ? this.$emit("onNavigationClick") : this.$emit("onTagPageClick"));
    }
  }
}, Nu = { class: "pages-button--left" }, Pu = { class: "pages-button--left-top" }, Du = { class: "pages-button--left-top-type" }, Mu = { class: "pages-button--left-bottom" }, Uu = { class: "pages-button--right" };
function Lu(e, t, r, n, s, a) {
  const i = x("pendo-tag"), l = x("pendo-icon"), o = de("pendo-tooltip");
  return re((d(), p("div", {
    class: $(["pages-button", {
      disabled: r.disabled
    }]),
    onClick: t[0] || (t[0] = (...u) => a.emitClick && a.emitClick(...u))
  }, [
    g("div", Nu, [
      g("div", Pu, [
        m(i, {
          label: `${r.tagged ? "Tagged" : "Untagged"}`,
          type: `${r.tagged ? "success" : "warning"}`,
          size: "mini",
          round: ""
        }, null, 8, ["label", "type"]),
        g("div", Du, U(r.type), 1)
      ]),
      g("div", Mu, U(a.displayUrl), 1)
    ]),
    g("div", Uu, [
      m(l, {
        type: "chevron-right",
        size: "16",
        stroke: "#2A2C35"
      })
    ])
  ], 2)), [
    [o, {
      arrow: !0,
      content: r.activeUrl,
      boundariesElement: "viewport",
      delay: { show: 300, hide: 0 },
      multiline: !0
    }]
  ]);
}
const ai = /* @__PURE__ */ F(Ou, [["render", Lu], ["__scopeId", "data-v-fd695828"]]), Vu = {
  name: "RepeatingComponent",
  components: {
    PendoButton: X
  },
  directives: {
    PendoTooltip: ce
  },
  props: {
    repeatingData: {
      type: Array,
      default: () => []
    },
    /**
     * Key to compare objects in `repeatingData`
     */
    idKey: {
      type: String,
      default: "repeatingKey"
    },
    unit: {
      type: String,
      default: "item"
    },
    allowEmpty: {
      type: Boolean,
      defaut: !1
    }
  },
  emits: ["addItem", "removeItem"],
  data() {
    return {
      itemKeyForHover: ""
    };
  },
  computed: {
    disableDelete() {
      return !this.allowEmpty && this.repeatingData.length === 1;
    },
    unitDisplayName() {
      return ti(this.unit);
    },
    tooltipConfig() {
      return {
        multiline: !0,
        arrow: !0,
        placement: "top-start",
        container: ".repeating-component",
        content: `Remove ${this.unitDisplayName}`
      };
    }
  },
  watch: {
    repeatingData: {
      handler(e) {
        !this.allowEmpty && Ae(e) && this.addItem();
      },
      immediate: !0
    }
  },
  methods: {
    removeItem(e) {
      this.$emit("removeItem", e);
    },
    addItem() {
      this.$emit("addItem");
    }
  }
}, $u = { class: "repeating-component" }, Fu = { class: "repeating-component__header" }, ju = { key: 0 }, Bu = ["onMouseenter"];
function Wu(e, t, r, n, s, a) {
  const i = x("pendo-button"), l = de("pendo-tooltip");
  return d(), p("div", $u, [
    g("div", Fu, [
      te(e.$slots, "header")
    ]),
    te(e.$slots, "description"),
    r.repeatingData ? (d(), p("div", ju, [
      m(Li, { name: "repeating-items" }, {
        default: I(() => [
          (d(!0), p(K, null, H(r.repeatingData, (o, u) => (d(), p("div", {
            ref_for: !0,
            ref: "items",
            key: o[r.idKey],
            "data-cy": "repeating-component__item",
            class: $(["repeating-component__item", {
              "repeating-component__item-hover": s.itemKeyForHover === o[r.idKey] && !a.disableDelete
            }])
          }, [
            te(e.$slots, "default", {
              index: u,
              item: o
            }),
            g("div", {
              class: "repeating-component__item-remove-wrapper",
              onMouseenter: (c) => s.itemKeyForHover = o[r.idKey],
              onMouseleave: t[0] || (t[0] = (c) => s.itemKeyForHover = "")
            }, [
              re(m(i, {
                class: "repeating-component__item-remove-wrapper-remove",
                type: "tertiary",
                icon: "trash-2",
                "icon-size": "18",
                disabled: a.disableDelete,
                onClick: (c) => a.removeItem(u)
              }, null, 8, ["disabled", "onClick"]), [
                [l, a.tooltipConfig]
              ])
            ], 40, Bu)
          ], 2))), 128))
        ], void 0, !0),
        _: 3
      })
    ])) : O("", !0),
    m(i, {
      theme: "app",
      type: "secondary",
      "prefix-icon": "plus",
      "data-cy": `New ${a.unitDisplayName}`,
      class: "repeating-component__item-add",
      label: `New ${a.unitDisplayName}`,
      onClick: a.addItem
    }, null, 8, ["data-cy", "label", "onClick"])
  ]);
}
const si = /* @__PURE__ */ F(Vu, [["render", Wu]]);
var ar, Ma;
function Ku() {
  if (Ma) return ar;
  Ma = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return ar = t, ar;
}
var sr, Ua;
function Hu() {
  if (Ua) return sr;
  Ua = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return sr = e, sr;
}
var ir, La;
function ii() {
  if (La) return ir;
  La = 1;
  var e = As(), t = Ku(), r = Hu();
  function n(s) {
    var a = -1, i = s == null ? 0 : s.length;
    for (this.__data__ = new e(); ++a < i; )
      this.add(s[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, ir = n, ir;
}
var lr, Va;
function zu() {
  if (Va) return lr;
  Va = 1;
  function e(t, r, n, s) {
    for (var a = t.length, i = n + (s ? 1 : -1); s ? i-- : ++i < a; )
      if (r(t[i], i, t))
        return i;
    return -1;
  }
  return lr = e, lr;
}
var or, $a;
function Gu() {
  if ($a) return or;
  $a = 1;
  function e(t) {
    return t !== t;
  }
  return or = e, or;
}
var ur, Fa;
function Zu() {
  if (Fa) return ur;
  Fa = 1;
  function e(t, r, n) {
    for (var s = n - 1, a = t.length; ++s < a; )
      if (t[s] === r)
        return s;
    return -1;
  }
  return ur = e, ur;
}
var cr, ja;
function ln() {
  if (ja) return cr;
  ja = 1;
  var e = zu(), t = Gu(), r = Zu();
  function n(s, a, i) {
    return a === a ? r(s, a, i) : e(s, t, i);
  }
  return cr = n, cr;
}
var dr, Ba;
function Yu() {
  if (Ba) return dr;
  Ba = 1;
  var e = ln();
  function t(r, n) {
    var s = r == null ? 0 : r.length;
    return !!s && e(r, n, 0) > -1;
  }
  return dr = t, dr;
}
var fr, Wa;
function Ju() {
  if (Wa) return fr;
  Wa = 1;
  function e(t, r, n) {
    for (var s = -1, a = t == null ? 0 : t.length; ++s < a; )
      if (n(r, t[s]))
        return !0;
    return !1;
  }
  return fr = e, fr;
}
var hr, Ka;
function li() {
  if (Ka) return hr;
  Ka = 1;
  function e(t, r) {
    return t.has(r);
  }
  return hr = e, hr;
}
var pr, Ha;
function Xu() {
  if (Ha) return pr;
  Ha = 1;
  var e = ii(), t = Yu(), r = Ju(), n = Ki(), s = ke(), a = li(), i = 200;
  function l(o, u, c, f) {
    var h = -1, b = t, R = !0, _ = o.length, v = [], C = u.length;
    if (!_)
      return v;
    c && (u = n(u, s(c))), f ? (b = r, R = !1) : u.length >= i && (b = a, R = !1, u = new e(u));
    e:
      for (; ++h < _; ) {
        var y = o[h], T = c == null ? y : c(y);
        if (y = f || y !== 0 ? y : 0, R && T === T) {
          for (var S = C; S--; )
            if (u[S] === T)
              continue e;
          v.push(y);
        } else b(u, T, f) || v.push(y);
      }
    return v;
  }
  return pr = l, pr;
}
var gr, za;
function Qu() {
  if (za) return gr;
  za = 1;
  var e = Jr(), t = qs(), r = fe(), n = e ? e.isConcatSpreadable : void 0;
  function s(a) {
    return r(a) || t(a) || !!(n && a && a[n]);
  }
  return gr = s, gr;
}
var _r, Ga;
function ec() {
  if (Ga) return _r;
  Ga = 1;
  var e = an(), t = Qu();
  function r(n, s, a, i, l) {
    var o = -1, u = n.length;
    for (a || (a = t), l || (l = []); ++o < u; ) {
      var c = n[o];
      s > 0 && a(c) ? s > 1 ? r(c, s - 1, a, i, l) : e(l, c) : i || (l[l.length] = c);
    }
    return l;
  }
  return _r = r, _r;
}
var br, Za;
function oi() {
  if (Za) return br;
  Za = 1;
  function e(t) {
    return t;
  }
  return br = e, br;
}
var mr, Ya;
function tc() {
  if (Ya) return mr;
  Ya = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return mr = e, mr;
}
var vr, Ja;
function rc() {
  if (Ja) return vr;
  Ja = 1;
  var e = tc(), t = Math.max;
  function r(n, s, a) {
    return s = t(s === void 0 ? n.length - 1 : s, 0), function() {
      for (var i = arguments, l = -1, o = t(i.length - s, 0), u = Array(o); ++l < o; )
        u[l] = i[s + l];
      l = -1;
      for (var c = Array(s + 1); ++l < s; )
        c[l] = i[l];
      return c[s] = a(u), e(n, this, c);
    };
  }
  return vr = r, vr;
}
var yr, Xa;
function nc() {
  if (Xa) return yr;
  Xa = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return yr = e, yr;
}
var xr, Qa;
function ac() {
  if (Qa) return xr;
  Qa = 1;
  var e = nc(), t = Ls(), r = oi(), n = t ? function(s, a) {
    return t(s, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : r;
  return xr = n, xr;
}
var Sr, es;
function sc() {
  if (es) return Sr;
  es = 1;
  var e = 800, t = 16, r = Date.now;
  function n(s) {
    var a = 0, i = 0;
    return function() {
      var l = r(), o = t - (l - i);
      if (i = l, o > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return s.apply(void 0, arguments);
    };
  }
  return Sr = n, Sr;
}
var Cr, ts;
function ic() {
  if (ts) return Cr;
  ts = 1;
  var e = ac(), t = sc(), r = t(e);
  return Cr = r, Cr;
}
var wr, rs;
function lc() {
  if (rs) return wr;
  rs = 1;
  var e = oi(), t = rc(), r = ic();
  function n(s, a) {
    return r(t(s, a, e), s + "");
  }
  return wr = n, wr;
}
var Er, ns;
function oc() {
  if (ns) return Er;
  ns = 1;
  var e = Zr(), t = be();
  function r(n) {
    return t(n) && e(n);
  }
  return Er = r, Er;
}
var Rr, as;
function uc() {
  if (as) return Rr;
  as = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Rr = e, Rr;
}
var Ar, ss;
function cc() {
  if (ss) return Ar;
  ss = 1;
  var e = Xu(), t = ec(), r = lc(), n = oc(), s = uc(), a = r(function(i, l) {
    var o = s(l);
    return n(o) && (o = void 0), n(i) ? e(i, t(l, 1, n, !0), void 0, o) : [];
  });
  return Ar = a, Ar;
}
var dc = cc();
const is = /* @__PURE__ */ Z(dc);
var Tr, ls;
function fc() {
  if (ls) return Tr;
  ls = 1;
  function e(t, r) {
    for (var n = -1, s = t == null ? 0 : t.length; ++n < s; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Tr = e, Tr;
}
var qr, os;
function ui() {
  if (os) return qr;
  os = 1;
  var e = ii(), t = fc(), r = li(), n = 1, s = 2;
  function a(i, l, o, u, c, f) {
    var h = o & n, b = i.length, R = l.length;
    if (b != R && !(h && R > b))
      return !1;
    var _ = f.get(i), v = f.get(l);
    if (_ && v)
      return _ == l && v == i;
    var C = -1, y = !0, T = o & s ? new e() : void 0;
    for (f.set(i, l), f.set(l, i); ++C < b; ) {
      var S = i[C], N = l[C];
      if (u)
        var E = h ? u(N, S, C, l, i, f) : u(S, N, C, i, l, f);
      if (E !== void 0) {
        if (E)
          continue;
        y = !1;
        break;
      }
      if (T) {
        if (!t(l, function(w, P) {
          if (!r(T, P) && (S === w || c(S, w, o, u, f)))
            return T.push(P);
        })) {
          y = !1;
          break;
        }
      } else if (!(S === N || c(S, N, o, u, f))) {
        y = !1;
        break;
      }
    }
    return f.delete(i), f.delete(l), y;
  }
  return qr = a, qr;
}
var Ir, us;
function hc() {
  if (us) return Ir;
  us = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(s, a) {
      n[++r] = [a, s];
    }), n;
  }
  return Ir = e, Ir;
}
var kr, cs;
function pc() {
  if (cs) return kr;
  cs = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(s) {
      n[++r] = s;
    }), n;
  }
  return kr = e, kr;
}
var Or, ds;
function gc() {
  if (ds) return Or;
  ds = 1;
  var e = Jr(), t = zs(), r = Ts(), n = ui(), s = hc(), a = pc(), i = 1, l = 2, o = "[object Boolean]", u = "[object Date]", c = "[object Error]", f = "[object Map]", h = "[object Number]", b = "[object RegExp]", R = "[object Set]", _ = "[object String]", v = "[object Symbol]", C = "[object ArrayBuffer]", y = "[object DataView]", T = e ? e.prototype : void 0, S = T ? T.valueOf : void 0;
  function N(E, w, P, q, D, B, L) {
    switch (P) {
      case y:
        if (E.byteLength != w.byteLength || E.byteOffset != w.byteOffset)
          return !1;
        E = E.buffer, w = w.buffer;
      case C:
        return !(E.byteLength != w.byteLength || !B(new t(E), new t(w)));
      case o:
      case u:
      case h:
        return r(+E, +w);
      case c:
        return E.name == w.name && E.message == w.message;
      case b:
      case _:
        return E == w + "";
      case f:
        var W = s;
      case R:
        var z = q & i;
        if (W || (W = a), E.size != w.size && !z)
          return !1;
        var G = L.get(E);
        if (G)
          return G == w;
        q |= l, L.set(E, w);
        var ne = n(W(E), W(w), q, D, B, L);
        return L.delete(E), ne;
      case v:
        if (S)
          return S.call(E) == S.call(w);
    }
    return !1;
  }
  return Or = N, Or;
}
var Nr, fs;
function _c() {
  if (fs) return Nr;
  fs = 1;
  var e = Hs(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function s(a, i, l, o, u, c) {
    var f = l & t, h = e(a), b = h.length, R = e(i), _ = R.length;
    if (b != _ && !f)
      return !1;
    for (var v = b; v--; ) {
      var C = h[v];
      if (!(f ? C in i : n.call(i, C)))
        return !1;
    }
    var y = c.get(a), T = c.get(i);
    if (y && T)
      return y == i && T == a;
    var S = !0;
    c.set(a, i), c.set(i, a);
    for (var N = f; ++v < b; ) {
      C = h[v];
      var E = a[C], w = i[C];
      if (o)
        var P = f ? o(w, E, C, i, a, c) : o(E, w, C, a, i, c);
      if (!(P === void 0 ? E === w || u(E, w, l, o, c) : P)) {
        S = !1;
        break;
      }
      N || (N = C == "constructor");
    }
    if (S && !N) {
      var q = a.constructor, D = i.constructor;
      q != D && "constructor" in a && "constructor" in i && !(typeof q == "function" && q instanceof q && typeof D == "function" && D instanceof D) && (S = !1);
    }
    return c.delete(a), c.delete(i), S;
  }
  return Nr = s, Nr;
}
var Pr, hs;
function bc() {
  if (hs) return Pr;
  hs = 1;
  var e = Us(), t = ui(), r = gc(), n = _c(), s = Ie(), a = fe(), i = Gr(), l = Is(), o = 1, u = "[object Arguments]", c = "[object Array]", f = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
  function R(_, v, C, y, T, S) {
    var N = a(_), E = a(v), w = N ? c : s(_), P = E ? c : s(v);
    w = w == u ? f : w, P = P == u ? f : P;
    var q = w == f, D = P == f, B = w == P;
    if (B && i(_)) {
      if (!i(v))
        return !1;
      N = !0, q = !1;
    }
    if (B && !q)
      return S || (S = new e()), N || l(_) ? t(_, v, C, y, T, S) : r(_, v, w, C, y, T, S);
    if (!(C & o)) {
      var L = q && b.call(_, "__wrapped__"), W = D && b.call(v, "__wrapped__");
      if (L || W) {
        var z = L ? _.value() : _, G = W ? v.value() : v;
        return S || (S = new e()), T(z, G, C, y, S);
      }
    }
    return B ? (S || (S = new e()), n(_, v, C, y, T, S)) : !1;
  }
  return Pr = R, Pr;
}
var Dr, ps;
function mc() {
  if (ps) return Dr;
  ps = 1;
  var e = bc(), t = be();
  function r(n, s, a, i, l) {
    return n === s ? !0 : n == null || s == null || !t(n) && !t(s) ? n !== n && s !== s : e(n, s, a, i, r, l);
  }
  return Dr = r, Dr;
}
var Mr, gs;
function vc() {
  if (gs) return Mr;
  gs = 1;
  var e = mc();
  function t(r, n) {
    return e(r, n);
  }
  return Mr = t, Mr;
}
var yc = vc();
const Ur = /* @__PURE__ */ Z(yc), xc = 420, Sc = {
  name: "SuggestedPagesTable",
  components: {
    PendoActionsCell: Mi,
    PendoButton: X,
    PendoTable: Di,
    PendoEditableContent: xs,
    PendoEmptyState: Pi,
    PendoModal: Kr,
    PendoIcon: ge,
    PendoPopover: Ni,
    CountableTableExpander: en
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    columns: {
      type: Array,
      default: () => [
        { type: "checkbox" },
        { prop: "name", label: "Page Name", sortable: !0, width: 400 },
        { prop: "rule", label: "Include Rules", sortable: !0, width: 300 },
        { prop: "samples", label: "Sample URLs", sortable: !0, width: 500 },
        { prop: "application", label: "Application", sortable: !0 },
        {
          sortable: !0,
          prop: "numLoads",
          label: "Number of Views",
          async: !0,
          formatter: (e) => Ee(e, "numLoads", 0),
          width: 150
        },
        { prop: "actions", label: "", width: 100 }
      ]
    },
    pages: {
      type: Array,
      required: !0
    },
    sampleTimeMessage: {
      type: String,
      default: "6 days"
    },
    theme: {
      type: String,
      default: "app",
      validator: (e) => ["app", "dark", "p2", "p2-light", "p2-dark"].includes(e)
    },
    isEmpty: {
      type: Boolean,
      default: !1
    },
    rowKey: {
      type: String,
      default: "id"
    },
    resizable: {
      type: Boolean,
      default: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    isDeleting: {
      type: Boolean,
      default: !1
    },
    isAccepting: {
      type: Boolean,
      default: !1
    },
    disableNotifications: {
      type: Boolean,
      default: !1
    },
    isDefaultCollapsed: {
      type: Boolean,
      default: !0
    },
    filters: {
      type: [Object, Array],
      default: null
    }
  },
  data() {
    return {
      expandedSamples: {},
      selectedPages: [],
      status: null,
      selectedRow: null,
      showConfirmDeleteModal: !1,
      showSuggestedPagesTableSettings: !1,
      MAX_HEIGHT: xc
    };
  },
  computed: {
    tableStatus() {
      const e = {
        EMPTY: "empty"
      };
      return this.pages.length === 0 ? e.EMPTY : "";
    },
    confirmDeleteMessage() {
      let e = this.multiplePagesSelected ? `${this.selectedPages.length} suggested pages` : "1 suggested page";
      return e += " will no longer be accessible and cannot be recovered. This action cannot be undone.", e;
    },
    confirmButtonConfig() {
      return {
        type: "danger",
        label: this.multiplePagesSelected ? "Delete Suggested Pages" : "Delete Suggested Page",
        theme: this.theme,
        loading: this.isDeleting
      };
    },
    multiplePagesSelected() {
      return !this.selectedRow && this.selectedPages && this.selectedPages.length > 1;
    },
    hasTooltipTextSlot() {
      return !!this.$slots.tooltipText;
    }
  },
  watch: {
    isDeleting(e) {
      this.showConfirmDeleteModal && !e && (this.showConfirmDeleteModal = !1, this.selectedPages = {});
    },
    pages(e, t) {
      const r = is(t, e, Ur);
      if (Ur(r, this.selectedPages))
        this.selectedPages = [];
      else {
        const s = is(this.selectedPages, r, Ur);
        this.selectedPages = s;
      }
    }
  },
  mounted() {
    this.isDefaultCollapsed && this.collapseSuggestedPagesTable();
  },
  methods: {
    acceptBulk() {
      this.selectedPages.length > 0 && this.$emit("accept-bulk", this.selectedPages);
    },
    toggleConfirmDeleteModal(e, t) {
      this.selectedRow = null, this.showConfirmDeleteModal = e, e && t && (this.selectedRow = t);
    },
    confirmDelete() {
      this.selectedRow ? this.$emit("delete-one", this.selectedRow) : this.$emit("delete-bulk", this.selectedPages);
    },
    acceptOne(e) {
      this.$emit("accept-one", e);
    },
    pageSelected(e) {
      this.selectedPages = e.selectedRows;
    },
    resetFilters() {
      this.selectedPages = [], this.$emit("reset-filters", !0);
    },
    collapseSuggestedPagesTable() {
      this.$refs.suggestedPagesTable.collapseTable();
    },
    collapseChange(e) {
      this.$emit("collapse-change", e);
    },
    onSamplesExpanded(e, t) {
      this.$set(this.expandedSamples, e.id, t);
    }
  }
}, Cc = { class: "suggested-pages-table" }, wc = {
  key: 0,
  class: "red-dot"
}, Ec = { class: "suggested-pages-table-popover-container" }, Rc = { class: "suggested-pages-table-popover-text" }, Ac = {
  key: 1,
  class: "selected-actions"
}, Tc = { class: "info-text" }, qc = { class: "suggested-pages-table--name" }, Ic = { class: "suggested-pages-table--samples" };
function kc(e, t, r, n, s, a) {
  const i = x("pendo-icon"), l = x("pendo-popover"), o = x("pendo-button"), u = x("pendo-editable-content"), c = x("countable-table-expander"), f = x("pendo-actions-cell"), h = x("pendo-empty-state"), b = x("pendo-table"), R = x("pendo-modal");
  return d(), p("main", Cc, [
    m(b, {
      ref: "suggestedPagesTable",
      title: r.title,
      data: r.pages,
      columns: r.columns,
      "max-height": s.MAX_HEIGHT,
      "row-key": r.rowKey,
      status: a.tableStatus,
      resizable: r.resizable,
      loading: r.loading,
      "checkbox-config": { reserve: !0 },
      filters: r.filters,
      collapsible: "",
      onSelectChange: t[1] || (t[1] = (_) => a.pageSelected(_)),
      onCollapseChange: a.collapseChange
    }, {
      headerPrefix: I(() => [
        !r.disableNotifications && !r.isEmpty ? (d(), p("div", wc)) : O("", !0)
      ]),
      headerActions: I(() => [
        a.hasTooltipTextSlot ? (d(), M(l, {
          key: 0,
          class: "suggested-pages-popover",
          delay: { show: 0, hide: 750 },
          arrow: !0,
          theme: "light"
        }, {
          popover: I(() => [
            g("div", Ec, [
              g("div", Rc, [
                m(i, {
                  class: "popover-text-info-icon",
                  type: "info",
                  size: "16"
                }),
                te(e.$slots, "tooltipText")
              ])
            ])
          ]),
          default: I(() => [
            m(i, {
              type: "info",
              size: "16"
            })
          ], void 0, !0),
          _: 3
        })) : O("", !0),
        s.selectedPages.length > 0 ? (d(), p("div", Ac, [
          t[3] || (t[3] = g("span", { class: "header-divider" }, "|", -1)),
          m(o, {
            theme: r.theme,
            label: s.selectedPages.length === 1 ? "Accept Tag" : "Accept Tags",
            loading: r.isAccepting,
            "prefix-icon": "check-square",
            type: "tertiary",
            class: "suggested-actions",
            onClick: a.acceptBulk
          }, null, 8, ["theme", "label", "loading", "onClick"]),
          m(o, {
            theme: r.theme,
            label: s.selectedPages.length === 1 ? "Delete Tag" : "Delete Tags",
            "prefix-icon": "trash-2",
            type: "tertiary",
            class: "suggested-actions",
            onClick: t[0] || (t[0] = (_) => a.toggleConfirmDeleteModal(!0))
          }, null, 8, ["theme", "label"])
        ])) : O("", !0),
        g("div", Tc, " The data in this table is sampled and reflects the last " + U(r.sampleTimeMessage), 1)
      ]),
      name: I(({ row: _ }) => [
        g("div", qc, [
          m(u, {
            modelValue: _.name,
            "onUpdate:modelValue": (v) => _.name = v,
            class: "suggested-pages-table--name--inline-edit"
          }, {
            append: I(({ confirm: v, cancel: C, pending: y }) => [
              m(o, {
                loading: y,
                theme: "app",
                icon: "check",
                type: "primary",
                onClick: v
              }, null, 8, ["loading", "onClick"]),
              m(o, {
                theme: "app",
                type: "secondary",
                icon: "x",
                onClick: C
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      samples: I(({ row: _ }) => [
        g("div", Ic, [
          m(c, {
            data: _.samples,
            "data-units": "URLs",
            "is-expanded": !!s.expandedSamples[_.id],
            onExpanded: (v) => a.onSamplesExpanded(_, v)
          }, null, 8, ["data", "is-expanded", "onExpanded"])
        ])
      ]),
      actions: I(({ row: _ }) => [
        m(f, {
          row: _,
          actions: [
            {
              type: "accept",
              icon: "check-square",
              tooltip: "Accept Tag"
            },
            {
              type: "delete",
              icon: "trash-2",
              tooltip: "Delete Tag"
            }
          ],
          onDelete: (v) => a.toggleConfirmDeleteModal(!0, _),
          onAccept: (v) => a.acceptOne(_)
        }, null, 8, ["row", "onDelete", "onAccept"])
      ]),
      empty: I(() => [
        r.isEmpty ? (d(), M(h, {
          key: 0,
          title: "Come back later",
          description: `No pages with load events have been detected in the past ${r.sampleTimeMessage}`
        }, {
          icon: I(() => t[4] || (t[4] = [
            g("img", {
              class: "suggested-pages-table__empty-icon",
              src: "https://cdn.pendo.io/img/suggested-pages-empty-state.png"
            }, null, -1)
          ])),
          _: 1
        }, 8, ["description"])) : (d(), M(h, {
          key: 1,
          title: "No more to accept here!",
          description: "Reset your filters to see the full list of the suggested pages you need to take action on."
        }, {
          icon: I(() => t[5] || (t[5] = [
            g("img", {
              class: "suggested-pages-table__filter-icon",
              src: "https://cdn.pendo.io/img/suggested-pages-filter-state.png"
            }, null, -1)
          ])),
          actions: I(() => [
            m(o, {
              theme: r.theme,
              type: "primary",
              label: "Reset Filters",
              onClick: a.resetFilters
            }, null, 8, ["theme", "onClick"])
          ]),
          _: 1
        }))
      ]),
      _: 3
    }, 8, ["title", "data", "columns", "max-height", "row-key", "status", "resizable", "loading", "filters", "onCollapseChange"]),
    m(R, {
      visible: s.showConfirmDeleteModal,
      type: "confirmation",
      title: a.multiplePagesSelected ? "Delete Suggested Pages?" : "Delete Suggested Page?",
      message: a.confirmDeleteMessage,
      "confirm-button-config": a.confirmButtonConfig,
      "cancel-button-config": { type: "secondary", label: "Cancel" },
      onCancel: t[2] || (t[2] = (_) => a.toggleConfirmDeleteModal(!1)),
      onConfirm: a.confirmDelete
    }, null, 8, ["visible", "title", "message", "confirm-button-config", "onConfirm"])
  ]);
}
const ci = /* @__PURE__ */ F(Sc, [["render", kc]]), Oc = {
  name: "TaggingOnIngestionSettings",
  components: {
    PendoCard: Ui,
    PendoToggle: Ss,
    PendoModal: Kr,
    PendoButton: X,
    PendoForm: Es,
    PendoFormItem: ws,
    PendoInput: Cs
  },
  props: {
    autoFeatureConfig: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      showDisableModal: !1,
      showEditMaxModal: !1,
      form: {
        input: ""
      },
      maxFeaturesInput: "",
      isFormValid: !1,
      rules: {
        input: [
          {
            required: !0,
            message: "Number is required.",
            trigger: ["blur", "change"]
          },
          { validator: this.validateInput, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  computed: {
    isToggleOn() {
      return Ee(this.autoFeatureConfig, "enabled", !1);
    },
    autoFeatureCount() {
      return Ee(this.autoFeatureConfig, "autoFeatureCount", "n/a");
    },
    maxFeatures() {
      return Ee(this.autoFeatureConfig, "maxFeatures", "n/a");
    }
  },
  watch: {
    maxFeatures: {
      handler(e) {
        this.form.input = e;
      },
      immediate: !0
    }
  },
  methods: {
    onToggleChange(e) {
      e ? this.emitToggleChangeAndCloseModal(e) : this.showDisableModal = !0;
    },
    emitToggleChangeAndCloseModal(e) {
      this.$emit("update", "enabled", e), this.showDisableModal = !1;
    },
    validateInput(e, t, r) {
      t < this.autoFeatureCount ? r(new Error(`Max cannot be less than ${this.autoFeatureCount} already created features.`)) : t > 1500 ? r(new Error("Max cannot exceed 1500.")) : r();
    },
    emitMaxFeaturesChangeAndCloseModal() {
      this.$emit("update", "maxFeatures", parseInt(this.form.input)), this.closeEditMaxModal();
    },
    closeEditMaxModal() {
      this.showEditMaxModal = !1, this.form.input = this.maxFeatures;
    }
  }
}, Nc = { class: "tagging-on-ingestion-settings" }, Pc = {
  key: 0,
  class: "tagging-on-ingestion-settings__container"
}, Dc = { class: "tagging-on-ingestion-settings__max-features-container" }, Mc = { class: "tagging-on-ingestion-settings__max-features-label" }, Uc = { class: "tagging-on-ingestion-settings__max-features-count" }, Lc = { class: "tagging-on-ingestion-settings__edit-max" }, Vc = { class: "tagging-on-ingestion-settings__edit-max-modal-input" };
function $c(e, t, r, n, s, a) {
  const i = x("pendo-toggle"), l = x("pendo-button"), o = x("pendo-card"), u = x("pendo-input"), c = x("pendo-form-item"), f = x("pendo-form"), h = x("pendo-modal");
  return d(), p("div", Nc, [
    m(o, { title: "Automatic Tagging with Custom HTML Attributes" }, {
      headerRight: I(() => [
        m(i, {
          value: a.isToggleOn,
          onChange: a.onToggleChange
        }, null, 8, ["value", "onChange"])
      ]),
      default: I(() => [
        t[8] || (t[8] = g("div", { class: "tagging-on-ingestion-settings__message" }, " Turn this flag on to have Pendo automatically create new Feature tags that contain Custom HTML Attributes. You must first add the attributes to the 'Collect Custom HTML Attributes' section, after which they will be accessible in the dropdown menu below within 15 minutes of being added. ", -1)),
        a.isToggleOn ? (d(), p("div", Pc, [
          g("div", Dc, [
            g("div", Mc, [
              g("span", Uc, U(a.autoFeatureCount) + "/" + U(a.maxFeatures), 1),
              t[6] || (t[6] = ee(" features created "))
            ]),
            g("div", Lc, [
              m(l, {
                theme: "app",
                type: "link",
                onClick: t[0] || (t[0] = (b) => s.showEditMaxModal = !0)
              }, {
                default: I(() => t[7] || (t[7] = [
                  ee(" Edit Max ")
                ]), void 0, !0),
                _: 1
              })
            ])
          ])
        ])) : O("", !0)
      ], void 0, !0),
      _: 1
    }),
    m(h, {
      class: "tagging-on-ingestion-settings__edit-max-modal",
      visible: s.showEditMaxModal,
      title: "Max Number of Features",
      height: "auto",
      width: "520",
      "confirm-button-config": { type: "primary", theme: "app", label: "Save", disabled: !s.isFormValid },
      "cancel-button-config": { type: "secondary", theme: "app", label: "Cancel" },
      onConfirm: a.emitMaxFeaturesChangeAndCloseModal,
      onCancel: a.closeEditMaxModal,
      onClose: a.closeEditMaxModal
    }, {
      default: I(() => [
        t[9] || (t[9] = g("div", { class: "tagging-on-ingestion-settings__edit-max-modal-message" }, " Set the max number of features you want to be created through Automatic Tagging with Custom HTML Attributes. Max cannot exceed 1500. ", -1)),
        g("div", Vc, [
          m(f, {
            ref: "form",
            modelValue: s.isFormValid,
            "onUpdate:modelValue": t[2] || (t[2] = (b) => s.isFormValid = b),
            model: s.form
          }, {
            default: I(() => [
              m(c, {
                prop: "input",
                rules: s.rules.input
              }, {
                default: I(() => [
                  m(u, {
                    modelValue: s.form.input,
                    "onUpdate:modelValue": t[1] || (t[1] = (b) => s.form.input = b),
                    type: "number",
                    width: "mini"
                  }, null, 8, ["modelValue"])
                ], void 0, !0),
                _: 1
              }, 8, ["rules"])
            ], void 0, !0),
            _: 1
          }, 8, ["modelValue", "model"])
        ])
      ], void 0, !0),
      _: 1
    }, 8, ["visible", "confirm-button-config", "onConfirm", "onCancel", "onClose"]),
    m(h, {
      visible: s.showDisableModal,
      title: "Warning",
      height: "auto",
      "confirm-button-config": { type: "danger", theme: "app", label: "Turn Off" },
      "cancel-button-config": { type: "secondary", theme: "app", label: "Cancel" },
      onConfirm: t[3] || (t[3] = (b) => a.emitToggleChangeAndCloseModal(!1)),
      onCancel: t[4] || (t[4] = (b) => s.showDisableModal = !1),
      onClose: t[5] || (t[5] = (b) => s.showDisableModal = !1)
    }, {
      body: I(() => t[10] || (t[10] = [
        g("div", { class: "tagging-on-ingestion-settings__toggle-modal-message" }, [
          g("div", null, " By turning off this setting, you are opting out of automatic creation of feature tags. This will not impact feature tags that have already been created. "),
          g("br"),
          g("div", null, [
            ee(" For questions, please reach out directly to your Pendo support representative or "),
            g("a", { href: "mailto:support@pendo.io" }, "contact support.")
          ])
        ], -1)
      ])),
      _: 1
    }, 8, ["visible"])
  ]);
}
const di = /* @__PURE__ */ F(Oc, [["render", $c], ["__scopeId", "data-v-3b0768e8"]]);
var Lr, _s;
function Fc() {
  if (_s) return Lr;
  _s = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return Lr = t, Lr;
}
var Vr, bs;
function jc() {
  if (bs) return Vr;
  bs = 1;
  var e = Fc(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return Vr = r, Vr;
}
var $r, ms;
function Bc() {
  if (ms) return $r;
  ms = 1;
  var e = ln();
  function t(r, n) {
    for (var s = r.length; s-- && e(n, r[s], 0) > -1; )
      ;
    return s;
  }
  return $r = t, $r;
}
var Fr, vs;
function Wc() {
  if (vs) return Fr;
  vs = 1;
  var e = ln();
  function t(r, n) {
    for (var s = -1, a = r.length; ++s < a && e(n, r[s], 0) > -1; )
      ;
    return s;
  }
  return Fr = t, Fr;
}
var jr, ys;
function Kc() {
  if (ys) return jr;
  ys = 1;
  var e = Hi(), t = jc(), r = Xs(), n = Bc(), s = Wc(), a = ei(), i = _e();
  function l(o, u, c) {
    if (o = i(o), o && (c || u === void 0))
      return t(o);
    if (!o || !(u = e(u)))
      return o;
    var f = a(o), h = a(u), b = s(f, h), R = n(f, h) + 1;
    return r(f, b, R).join("");
  }
  return jr = l, jr;
}
var Hc = Kc();
const zc = /* @__PURE__ */ Z(Hc), Gc = {
  name: "TextareaInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    maxCharactersWarn: {
      type: Number,
      default: 200
    },
    maxCharacters: {
      type: Number,
      default: 280
    },
    lineClamp: {
      type: Number,
      default: null
    },
    lineHeight: {
      type: [Number, String],
      default: 20
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  computed: {
    characterCount() {
      return this.inputValue.length;
    },
    showCharacterCount() {
      return this.characterCount >= this.maxCharactersWarn;
    },
    hasValidationError() {
      return !this.allowEmpty && !zc(this.inputValue) ? !0 : this.inputValue.length > this.maxCharacters;
    },
    inputStyles() {
      return {
        "line-height": `${this.lineHeight}px`
      };
    },
    maxHeight() {
      return this.lineClamp ? this.lineClamp * this.lineHeight : 80;
    }
  },
  watch: {
    value: {
      handler(e) {
        this.inputValue = e.replace(/\n/g, ""), this.$emit("input", this.inputValue), this.$emit("error", this.hasValidationError), this.$nextTick(() => {
          this.updateElementSize(this.$refs.textarea);
        });
      },
      immediate: !0
    },
    inputValue: {
      handler(e) {
        this.inputValue = e.replace(/\n/g, ""), this.$emit("input", this.inputValue), this.$emit("error", this.hasValidationError), this.$nextTick(() => {
          this.updateElementSize(this.$refs.textarea);
        });
      }
    }
  },
  methods: {
    focus() {
      if (document.activeElement !== this.$refs.textarea)
        return this.$refs.textarea.focus();
    },
    handleFocus() {
      window.addEventListener("mousedown", this.handleMousedown);
    },
    handleMousedown(e) {
      this.lastMousedownTarget = e.target;
    },
    updateElementSize(e, t = this.maxHeight) {
      e.style.height = "auto";
      const r = e.scrollHeight > 0 ? e.scrollHeight : this.lineHeight, n = r > t ? t : r;
      e.style.height = `${n}px`;
    }
  }
}, Zc = ["placeholder"], Yc = {
  key: 0,
  class: "textarea-input__character-count"
};
function Jc(e, t, r, n, s, a) {
  return d(), p("div", {
    class: $(["textarea-input", {
      "has-error": a.hasValidationError,
      "has-character-count": a.showCharacterCount || a.hasValidationError
    }]),
    onClick: t[2] || (t[2] = (...i) => a.focus && a.focus(...i))
  }, [
    re(g("textarea", {
      ref: "textarea",
      "onUpdate:modelValue": t[0] || (t[0] = (i) => s.inputValue = i),
      rows: "1",
      class: "textarea-input__input",
      style: Hr(a.inputStyles),
      placeholder: r.placeholder,
      onFocus: t[1] || (t[1] = (...i) => a.handleFocus && a.handleFocus(...i))
    }, null, 44, Zc), [
      [Vi, s.inputValue]
    ]),
    a.showCharacterCount || a.hasValidationError ? (d(), p("span", Yc, U(a.characterCount) + "/" + U(r.maxCharacters), 1)) : O("", !0)
  ], 2);
}
const fi = /* @__PURE__ */ F(Gc, [["render", Jc], ["__scopeId", "data-v-b981dc27"]]), Xc = {
  name: "UpDownNav",
  components: {
    PendoButton: X
  },
  props: {
    upArrowDisabled: {
      required: !0,
      type: Boolean
    },
    downArrowDisabled: {
      required: !0,
      type: Boolean
    }
  }
}, Qc = { class: "up-down-nav" };
function ed(e, t, r, n, s, a) {
  const i = x("pendo-button");
  return d(), p("div", Qc, [
    te(e.$slots, "nav", {}, void 0, !0),
    m(i, {
      theme: "app",
      class: "up-down-nav--up-arrow",
      type: "secondary",
      icon: "arrow-up",
      disabled: r.upArrowDisabled,
      onClick: t[0] || (t[0] = (l) => e.$emit("up-arrow-clicked"))
    }, null, 8, ["disabled"]),
    m(i, {
      theme: "app",
      class: "up-down-nav--down-arrow",
      type: "secondary",
      icon: "arrow-down",
      disabled: r.downArrowDisabled,
      onClick: t[1] || (t[1] = (l) => e.$emit("down-arrow-clicked"))
    }, null, 8, ["disabled"])
  ]);
}
const hi = /* @__PURE__ */ F(Xc, [["render", ed], ["__scopeId", "data-v-56d3ad62"]]);
function Wr(e) {
  Wr.installed || (Wr.installed = !0, e.component("CollapseDetails", Ns), e.component("ConfigureSelector", Ds), e.component("CountableTableExpander", en), e.component("CountableTableRules", Ms), e.component("CustomRuleBuilder", Js), e.component("FeaturesButton", ri), e.component("PageRuleTester", ni), e.component("PagesButton", ai), e.component("RepeatingComponent", si), e.component("SelectorEditor", Qr), e.component("SuggestedPagesTable", ci), e.component("TaggingOnIngestion", di), e.component("TextareaInput", fi), e.component("UpDownNav", hi));
}
const pi = {
  install: Wr,
  CollapseDetails: Ns,
  ConfigureSelector: Ds,
  CountableTableExpander: en,
  CountableTableRules: Ms,
  CustomRuleBuilder: Js,
  FeaturesButton: ri,
  PageRuleTester: ni,
  PagesButton: ai,
  RepeatingComponent: si,
  SelectorEditor: Qr,
  SuggestedPagesTable: ci,
  TaggingOnIngestionSettings: di,
  TextareaInput: fi,
  UpDownNav: hi
};
let qe = null;
typeof window < "u" ? qe = window.Vue : typeof global < "u" && (qe = global.Vue);
qe && qe.use(pi);
const ad = {
  ...pi
};
export {
  Ns as CollapseDetails,
  Ds as ConfigureSelector,
  en as CountableTableExpander,
  Ms as CountableTableRules,
  Js as CustomRuleBuilder,
  ri as FeaturesButton,
  ni as PageRuleTester,
  ai as PagesButton,
  si as RepeatingComponent,
  Qr as SelectorEditor,
  ci as SuggestedPagesTable,
  di as TaggingOnIngestionSettings,
  fi as TextareaInput,
  hi as UpDownNav,
  ad as default,
  Wr as install
};
